{
  "about.blocks": "Συντονιζόμενοι διακομιστές",
  "about.contact": "Επικοινωνία:",
  "about.default_locale": "Προεπιλογή",
  "about.disclaimer": "Το Mastodon είναι ελεύθερο λογισμικό ανοιχτού κώδικα και εμπορικό σήμα της Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Αιτιολογία μη διαθέσιμη",
  "about.domain_blocks.preamble": "Σε γενικές γραμμές το Mastodon σου επιτρέπει να βλέπεις περιεχόμενο και να αλληλεπιδράς με χρήστες από οποιονδήποτε άλλο διακομιστή σε ένα διασυνδεδεμένο σύμπαν διακομιστών (fediverse). Ακολουθούν οι εξαιρέσεις που ισχύουν για τον συγκεκριμένο διακομιστή.",
  "about.domain_blocks.silenced.explanation": "Συνήθως δε θα βλέπεις προφίλ και περιεχόμενο απ' αυτόν τον διακομιστή, εκτός αν κάνεις συγκεκριμένη αναζήτηση ή επιλέξεις να τον ακολουθήσεις.",
  "about.domain_blocks.silenced.title": "Περιορισμένος",
  "about.domain_blocks.suspended.explanation": "Τα δεδομένα αυτού του διακομιστή, δε θα επεξεργάζονται, δε θα αποθηκεύονται και δε θα ανταλλάσσονται, καθιστώντας οποιαδήποτε αλληλεπίδραση ή επικοινωνία με χρήστες από αυτόν το διακομιστή αδύνατη.",
  "about.domain_blocks.suspended.title": "Σε αναστολή",
  "about.language_label": "Γλώσσα",
  "about.not_available": "Αυτές οι πληροφορίες δεν έχουν γίνει διαθέσιμες σε αυτόν τον διακομιστή.",
  "about.powered_by": "Αποκεντρωμένο μέσο κοινωνικής δικτύωσης που βασίζεται στο {mastodon}",
  "about.rules": "Κανόνες διακομιστή",
  "account.account_note_header": "Προσωπική σημείωση",
  "account.activity": "Δραστηριότητα",
  "account.add_note": "Προσθέστε μια προσωπική σημείωση",
  "account.add_or_remove_from_list": "Προσθήκη ή Αφαίρεση από λίστες",
  "account.badges.admin": "Διαχειριστής",
  "account.badges.blocked": "Αποκλεισμένος",
  "account.badges.bot": "Αυτοματοποιημένος",
  "account.badges.domain_blocked": "Αποκλεισμένος τομέας",
  "account.badges.group": "Ομάδα",
  "account.badges.muted": "Σε σίγαση",
  "account.badges.muted_until": "Σε σίγαση μέχρι {until}",
  "account.block": "Αποκλεισμός @{name}",
  "account.block_domain": "Αποκλεισμός τομέα {domain}",
  "account.block_short": "Αποκλεισμός",
  "account.blocked": "Αποκλεισμένος/η",
  "account.cancel_follow_request": "Απόσυρση αιτήματος παρακολούθησης",
  "account.copy": "Αντιγραφή συνδέσμου προφίλ",
  "account.direct": "Ιδιωτική επισήμανση @{name}",
  "account.disable_notifications": "Σταμάτα να με ειδοποιείς όταν δημοσιεύει ο @{name}",
  "account.edit_note": "Επεξεργασία προσωπικής σημείωσης",
  "account.edit_profile": "Επεξεργασία προφίλ",
  "account.edit_profile_short": "Επεξεργασία",
  "account.enable_notifications": "Ειδοποίησέ με όταν δημοσιεύει ο @{name}",
  "account.endorse": "Ανάδειξη στο προφίλ",
  "account.familiar_followers_many": "Ακολουθείται από {name1}, {name2}, και {othersCount, plural, one {ένας ακόμα που ξέρεις} other {# ακόμα που ξέρεις}}",
  "account.familiar_followers_one": "Ακολουθείται από {name1}",
  "account.familiar_followers_two": "Ακολουθείται από {name1} και {name2}",
  "account.featured": "Αναδεδειγμένα",
  "account.featured.accounts": "Προφίλ",
  "account.featured.collections": "Συλλογές",
  "account.featured.new_collection": "Νέα συλλογή",
  "account.field_overflow": "Εμφάνιση πλήρους περιεχομένου",
  "account.filters.all": "Όλη η δραστηριότητα",
  "account.filters.boosts_toggle": "Εμφάνιση ενισχύσεων",
  "account.filters.posts_boosts": "Αναρτήσεις και ενισχύσεις",
  "account.filters.posts_only": "Αναρτήσεις",
  "account.filters.posts_replies": "Αναρτήσεις και απαντήσεις",
  "account.filters.replies_toggle": "Εμφάνιση απαντήσεων",
  "account.follow": "Ακολούθησε",
  "account.follow_back": "Ακολούθησε και εσύ",
  "account.follow_back_short": "Ακολούθησε και εσύ",
  "account.follow_request": "Αίτημα για ακολούθηση",
  "account.follow_request_cancel": "Ακύρωση αιτήματος",
  "account.follow_request_cancel_short": "Ακύρωση",
  "account.follow_request_short": "Αίτημα",
  "account.followers": "Ακόλουθοι",
  "account.followers.empty": "Κανείς δεν ακολουθεί αυτόν τον χρήστη ακόμη.",
  "account.followers_counter": "{count, plural, one {{counter} ακόλουθος} other {{counter} ακόλουθοι}}",
  "account.followers_you_know_counter": "{counter} που ξέρεις",
  "account.following": "Ακολουθείτε",
  "account.following_counter": "{count, plural, one {{counter} ακολουθεί} other {{counter} ακολουθεί}}",
  "account.follows.empty": "Αυτός ο χρήστης δεν ακολουθεί κανέναν ακόμη.",
  "account.follows_you": "Σε ακολουθεί",
  "account.go_to_profile": "Μετάβαση στο προφίλ",
  "account.hide_reblogs": "Απόκρυψη ενισχύσεων από @{name}",
  "account.in_memoriam": "Εις μνήμην.",
  "account.join_modal.day": "Ημέρα",
  "account.join_modal.me": "Έγινες μέλος στο {server} στις",
  "account.join_modal.me_anniversary": "Ευτυχισμένο Fediversary! Έγινες μέλος στο {server} στις",
  "account.join_modal.me_today": "Είναι η πρώτη σου μέρα στο {server}!",
  "account.join_modal.other": "Ο/Η {name} έγινε μέλος στο {server} στις",
  "account.join_modal.other_today": "Είναι η πρώτη μέρα του/της {name} στο {server}!",
  "account.join_modal.share.celebrate": "Μοιράσου μια εορταστική ανάρτηση",
  "account.join_modal.share.intro": "Μοιράσου μια εισαγωγική ανάρτηση",
  "account.join_modal.share.welcome": "Μοιράσου μια ανάρτηση καλωσορίσματος",
  "account.join_modal.years": "{number, plural, one {χρόνος} other {χρόνια}}",
  "account.joined_short": "Έγινε μέλος",
  "account.languages": "Αλλαγή εγγεγραμμένων γλωσσών",
  "account.last_active": "Τελευταία ενεργός",
  "account.link_verified_on": "Η ιδιοκτησία αυτού του συνδέσμου ελέγχθηκε στις {date}",
  "account.locked_info": "Η κατάσταση απορρήτου αυτού του λογαριασμού έχει ρυθμιστεί σε κλειδωμένη. Ο ιδιοκτήτης ελέγχει χειροκίνητα ποιος μπορεί να τον ακολουθήσει.",
  "account.media": "Πολυμέσα",
  "account.mention": "Επισήμανση @{name}",
  "account.menu.add_to_list": "Προσθήκη στη λίστα…",
  "account.menu.block": "Αποκλεισμός λογαριασμού",
  "account.menu.block_domain": "Αποκλεισμός {domain}",
  "account.menu.copied": "Αντιγραφή συνδέσμου λογαριασμού στο πρόχειρο",
  "account.menu.copy": "Αντιγραφή συνδέσμου",
  "account.menu.direct": "Ιδιωτική επισήμανση",
  "account.menu.hide_reblogs": "Απόκρυψη ενισχύσεων στο χρονολόγιο",
  "account.menu.mention": "Επισήμανση",
  "account.menu.mute": "Σίγαση λογαριασμού",
  "account.menu.note.description": "Ορατή μόνο σε εσάς",
  "account.menu.open_original_page": "Προβολή στο {domain}",
  "account.menu.remove_follower": "Αφαίρεση ακολούθου",
  "account.menu.report": "Αναφορά λογαριασμού",
  "account.menu.share": "Κοινοποίηση…",
  "account.menu.show_reblogs": "Εμφάνιση ενισχύσεων στο χρονολόγιο",
  "account.menu.unblock": "Άρση αποκλεισμού λογαριασμού",
  "account.menu.unblock_domain": "Άρση αποκλεισμού {domain}",
  "account.menu.unmute": "Άρση σίγασης λογαριασμού",
  "account.moved_to": "Ο/Η {name} έχει υποδείξει ότι ο νέος λογαριασμός του/της είναι τώρα:",
  "account.mute": "Σίγαση @{name}",
  "account.mute_notifications_short": "Σίγαση ειδοποιήσεων",
  "account.mute_short": "Σίγαση",
  "account.muted": "Σε σίγαση",
  "account.mutual": "Ακολουθείτε ο ένας τον άλλο",
  "account.name.copy": "Αντιγραφή πλήρους ονόματος χρήστη",
  "account.name.help.domain": "Το {domain} είναι ο διακομιστής που φιλοξενεί το προφίλ και τις αναρτήσεις του χρήστη.",
  "account.name.help.domain_self": "Το {domain} είναι ο διακομιστής σας που φιλοξενεί το προφίλ και τις αναρτήσεις σας.",
  "account.name.help.footer": "Ακριβώς όπως μπορείς να στείλεις email σε κόσμο χρησιμοποιώντας διαφορετικούς παρόχους ηλεκτρονικού ταχυδρομείου, μπορείς να αλληλεπιδράσεις με άτομα σε άλλους διακομιστές Mastodon, και με οποιονδήποτε σε άλλες εφαρμογές του Fediverse.",
  "account.name.help.header": "Ένα πλήρες όνομα χρήστη είναι σαν μια διεύθυνση email",
  "account.name.help.username": "Το {username} είναι το όνομα χρήστη αυτού του λογαριασμού στο διακομιστή τους. Κάποιος σε άλλο διακομιστή μπορεί να έχει το ίδιο όνομα χρήστη.",
  "account.name.help.username_self": "Το {username} είναι το όνομα χρήστη σας σε αυτόν το διακομιστή. Κάποιος σε άλλο διακομιστή μπορεί να έχει το ίδιο όνομα χρήστη.",
  "account.name_info": "Τι σημαίνει αυτό;",
  "account.no_bio": "Δεν υπάρχει περιγραφή.",
  "account.node_modal.callout": "Οι προσωπικές σημειώσεις είναι ορατές μόνο σε εσάς.",
  "account.node_modal.edit_title": "Επεξεργασία προσωπικής σημείωσης",
  "account.node_modal.error_unknown": "Δεν ήταν δυνατή η αποθήκευση της σημείωσης",
  "account.node_modal.field_label": "Προσωπική σημείωση",
  "account.node_modal.save": "Αποθήκευση",
  "account.node_modal.title": "Προσθέστε μια προσωπική σημείωση",
  "account.note.edit_button": "Επεξεργασία",
  "account.note.title": "Προσωπική σημείωση (ορατή μόνο σε εσάς)",
  "account.open_original_page": "Άνοιγμα πρωτότυπης σελίδας",
  "account.pending": "Εκκρεμεί",
  "account.posts": "Αναρτήσεις",
  "account.remove_from_followers": "Κατάργηση {name} από τους ακόλουθους",
  "account.report": "Αναφορά @{name}",
  "account.requested_follow": "Ο/Η {name} αιτήθηκε να σε ακολουθήσει",
  "account.share": "Κοινοποίηση του προφίλ @{name}",
  "account.show_reblogs": "Εμφάνιση ενισχύσεων από @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} ανάρτηση} other {{counter} αναρτήσεις}}",
  "account.timeline.pinned": "Καρφιτσωμένη",
  "account.timeline.pinned.view_all": "Προβολή όλων των καρφιτσωμένων αναρτήσεων",
  "account.unblock": "Άρση αποκλεισμού @{name}",
  "account.unblock_domain": "Άρση αποκλεισμού τομέα {domain}",
  "account.unblock_domain_short": "Άρση αποκλ.",
  "account.unblock_short": "Άρση αποκλεισμού",
  "account.unendorse": "Να μην αναδεικνύεται στο προφίλ",
  "account.unfollow": "Άρση ακολούθησης",
  "account.unmute": "Άρση σίγασης @{name}",
  "account.unmute_notifications_short": "Σίγαση ειδοποιήσεων",
  "account.unmute_short": "Κατάργηση σίγασης",
  "account_edit.advanced_settings.bot_hint": "Υποδεικνύει σε άλλους χρήστες ότι ο λογαριασμός αυτός εκτελεί κυρίως αυτοματοποιημένες ενέργειες και ίσως να μην παρακολουθείται",
  "account_edit.advanced_settings.bot_label": "Αυτοματοποιημένος λογαριασμός",
  "account_edit.advanced_settings.title": "Προχωρημένες ρυθμίσεις",
  "account_edit.bio.add_label": "Προσθήκη βιογραφικού",
  "account_edit.bio.edit_label": "Επεξεργασία βιογραφικού",
  "account_edit.bio.placeholder": "Προσθέστε μια σύντομη εισαγωγή για να βοηθήσετε άλλους να σας αναγνωρίσουν.",
  "account_edit.bio.title": "Βιογραφικό",
  "account_edit.bio_modal.add_title": "Προσθήκη βιογραφικού",
  "account_edit.bio_modal.edit_title": "Επεξεργασία βιογραφικού",
  "account_edit.column_button": "Έγινε",
  "account_edit.column_title": "Επεξεργασία Προφίλ",
  "account_edit.custom_fields.add_label": "Προσθήκη πεδίου",
  "account_edit.custom_fields.edit_label": "Επεξεργασία πεδίου",
  "account_edit.custom_fields.placeholder": "Προσθέστε τις αντωνυμίες σας, εξωτερικούς συνδέσμους ή οτιδήποτε άλλο θέλετε να μοιραστείτε.",
  "account_edit.custom_fields.reorder_button": "Αναδιάταξη πεδίων",
  "account_edit.custom_fields.tip_content": "Μπορείς εύκολα να προσθέσεις αξιοπιστία στον Mastodon λογαριασμό σου επαληθεύοντας συνδέσμους προς οποιεσδήποτε ιστοσελίδες κατέχεις.",
  "account_edit.custom_fields.tip_title": "Συμβουλή: Προσθήκη επαληθευμένων συνδέσμων",
  "account_edit.custom_fields.title": "Προσαρμοσμένα πεδία",
  "account_edit.custom_fields.verified_hint": "Πώς προσθέτω έναν επαληθευμένο σύνδεσμο;",
  "account_edit.display_name.add_label": "Προσθήκη εμφανιζόμενου ονόματος",
  "account_edit.display_name.edit_label": "Επεξεργασία εμφανιζόμενου ονόματος",
  "account_edit.display_name.placeholder": "Το εμφανιζόμενο όνομα σας είναι πως εμφανίζεται το όνομά σας στο προφίλ σας και στα χρονοδιαγράμματα.",
  "account_edit.display_name.title": "Εμφανιζόμενο όνομα",
  "account_edit.featured_hashtags.edit_label": "Προσθήκη ετικετών",
  "account_edit.featured_hashtags.placeholder": "Βοηθήστε τους άλλους να εντοπίσουν και να έχουν γρήγορη πρόσβαση στα αγαπημένα σας θέματα.",
  "account_edit.featured_hashtags.title": "Αναδεδειγμένες ετικέτες",
  "account_edit.field_actions.delete": "Διαγραφή πεδίου",
  "account_edit.field_actions.edit": "Επεξεργασία πεδίου",
  "account_edit.field_delete_modal.confirm": "Σίγουρα θέλετε να διαγράψετε αυτό το προσαρμοσμένο πεδίο; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
  "account_edit.field_delete_modal.delete_button": "Διαγραφή",
  "account_edit.field_delete_modal.title": "Διαγραφή προσαρμοσμένου πεδίου;",
  "account_edit.field_edit_modal.add_title": "Προσθήκη προσαρμοσμένου πεδίου",
  "account_edit.field_edit_modal.discard_confirm": "Απόρριψη",
  "account_edit.field_edit_modal.discard_message": "Έχετε μη αποθηκευμένες αλλαγές. Σίγουρα θέλετε να τις απορρίψετε;",
  "account_edit.field_edit_modal.edit_title": "Επεξεργασία προσαρμοσμένου πεδίου",
  "account_edit.field_edit_modal.length_warning": "Υπέρβαση του συνιστώμενου ορίου χαρακτήρων. Οι χρήστες κινητών ενδέχεται να μην βλέπουν το πεδίο σας πλήρως.",
  "account_edit.field_edit_modal.link_emoji_warning": "Δεν συνιστούμε τη χρήση προσαρμοσμένων emoji σε συνδυασμό με URL. Τα προσαρμοσμένα πεδία που περιέχουν και τα δύο θα εμφανίζονται ως κείμενο μόνο αντί ως σύνδεσμος, προκειμένου να αποφευχθεί η σύγχυση του χρήστη.",
  "account_edit.field_edit_modal.name_hint": "Π.χ. “Προσωπική ιστοσελίδα”",
  "account_edit.field_edit_modal.name_label": "Ετικέτα",
  "account_edit.field_edit_modal.url_warning": "Για να προσθέσεις έναν σύνδεσμο, παρακαλούμε να συμπεριλάβεις το {protocol} στην αρχή.",
  "account_edit.field_edit_modal.value_hint": "Π.χ. “https://example.me”",
  "account_edit.field_edit_modal.value_label": "Τιμή",
  "account_edit.field_reorder_modal.drag_cancel": "Η μετακίνηση ακυρώθηκε. Το πεδίο \"{item}\" αφέθηκε.",
  "account_edit.field_reorder_modal.drag_end": "Το πεδίο \"{item}\" αφέθηκε.",
  "account_edit.field_reorder_modal.drag_instructions": "Για να αναδιατάξετε τα προσαρμοσμένα πεδία, πατήστε Space ή Enter. Κατά τη μετακίνηση, χρησιμοποιήστε τα πλήκτρα βέλους για να μετακινήσετε το πεδίο πάνω ή κάτω. Πατήστε Space ή Enter ξανά για να ρίξετε το πεδίο στη νέα του θέση ή πατήστε Escape για να ακυρώσετε.",
  "account_edit.field_reorder_modal.drag_move": "Το πεδίο \"{item}\" μετακινήθηκε.",
  "account_edit.field_reorder_modal.drag_over": "Το πεδίο \"{item}\" μετακινήθηκε στο \"{over}\".",
  "account_edit.field_reorder_modal.drag_start": "Το πεδίο \"{item}\" σηκώθηκε.",
  "account_edit.field_reorder_modal.handle_label": "Μετακίνηση πεδίου \"{item}\"",
  "account_edit.field_reorder_modal.title": "Αναδιάταξη πεδίων",
  "account_edit.image_alt_modal.add_title": "Προσθήκη εναλλακτικού κειμένου",
  "account_edit.image_alt_modal.details_content": "ΚΑΝΕΤΕ: <ul> <li>Να περιγράφετε τον εαυτό σας όπως απεικονίζεται</li> <li>Να χρησιμοποιείτε τρίτο πρόσωπο (Π.χ. “Άλεξ” αντί για “εγώ”)</li> <li>Να είστε σύντομοι και περιεκτικοί – οι λίγες λέξεις μερικές φορές αρκούν</li> </ul> ΜΗΝ ΚΑΝΕΤΕ: <ul> <li>Να ξεκινάτε με “Φωτογραφία του” – είναι περιττό για τους αναγνώστες οθόνης</li> </ul> ΠΑΡΑΔΕΙΓΜΑ: <ul> <li>“Ο Άλεξ με μια πράσινη μπλούζα και γυαλιά”</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Συμβουλές: Εναλλακτικό κείμενο για εικόνες προφίλ",
  "account_edit.image_alt_modal.edit_title": "Επεξεργασία εναλλακτικού κειμένου",
  "account_edit.image_alt_modal.text_hint": "Το εναλλακτικό κείμενο βοηθά τους χρήστες με αναγνώστη οθόνης να κατανοήσουν το περιεχόμενό σας.",
  "account_edit.image_alt_modal.text_label": "Εναλλακτικό κείμενο",
  "account_edit.image_delete_modal.confirm": "Σίγουρα θέλετε να διαγράψετε αυτήν την εικόνα; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
  "account_edit.image_delete_modal.delete_button": "Διαγραφή",
  "account_edit.image_delete_modal.title": "Διαγραφή εικόνας;",
  "account_edit.image_edit.add_button": "Προσθήκη εικόνας",
  "account_edit.image_edit.alt_add_button": "Προσθήκη εναλλακτικού κειμένου",
  "account_edit.image_edit.alt_edit_button": "Επεξεργασία εναλλακτικού κειμένου",
  "account_edit.image_edit.remove_button": "Αφαίρεση εικόνας",
  "account_edit.image_edit.replace_button": "Αντικατάσταση εικόνας",
  "account_edit.item_list.delete": "Διαγραφή {name}",
  "account_edit.item_list.edit": "Επεξεργασία {name}",
  "account_edit.name_modal.add_title": "Προσθήκη εμφανιζόμενου ονόματος",
  "account_edit.name_modal.edit_title": "Επεξεργασία εμφανιζόμενου ονόματος",
  "account_edit.profile_tab.button_label": "Προσαρμογή",
  "account_edit.profile_tab.hint.description": "Αυτές οι ρυθμίσεις προσαρμόζουν τι βλέπουν οι χρήστες στο {server} στις επίσημες εφαρμογές, αλλά δεν μπορούν να εφαρμοστούν για χρήστες σε άλλους διακομιστές και εφαρμογές τρίτων.",
  "account_edit.profile_tab.hint.title": "Οι εμφανίσεις εξακολουθούν να ποικίλλουν",
  "account_edit.profile_tab.show_featured.description": "«Αναδεδειγμένα» είναι μια προαιρετική καρτέλα όπου μπορείτε να αναδείξετε άλλους λογαριασμούς.",
  "account_edit.profile_tab.show_featured.title": "Εμφάνιση καρτέλας «Αναδεδειγμένα»",
  "account_edit.profile_tab.show_media.description": "«Πολυμέσα» είναι μια προαιρετική καρτέλα που δείχνει τις αναρτήσεις σας που περιέχουν εικόνες ή βίντεο.",
  "account_edit.profile_tab.show_media.title": "Εμφάνιση καρτέλας «Πολυμέσα»",
  "account_edit.profile_tab.show_media_replies.description": "Όταν ενεργοποιηθεί, η καρτέλα Πολυμέσα εμφανίζει τόσο τις αναρτήσεις σας όσο και τις απαντήσεις σας σε αναρτήσεις άλλων ατόμων.",
  "account_edit.profile_tab.show_media_replies.title": "Συμπερίληψη απαντήσεων στην καρτέλα «Πολυμέσα»",
  "account_edit.profile_tab.show_relations.description": "Εμφανίζει τους λογαριασμούς που ακολουθείτε και τους ακολούθους σας σε άλλους χρήστες στο προφίλ σας. Ο κόσμος θα είναι ακόμα σε θέση να δει αν τους ακολουθείτε.",
  "account_edit.profile_tab.show_relations.title": "Εμφάνιση «Ακόλουθοι» και «Ακολουθείτε»",
  "account_edit.profile_tab.subtitle": "Προσαρμόστε το πώς εμφανίζεται το προφίλ σας.",
  "account_edit.profile_tab.title": "Ρυθμίσεις εμφάνισης προφίλ",
  "account_edit.save": "Αποθήκευση",
  "account_edit.upload_modal.back": "Πίσω",
  "account_edit.upload_modal.done": "Έγινε",
  "account_edit.upload_modal.next": "Επόμενο",
  "account_edit.upload_modal.step_crop.zoom": "Μεγέθυνση",
  "account_edit.upload_modal.step_upload.button": "Περιήγηση αρχείων",
  "account_edit.upload_modal.step_upload.dragging": "Αποθέστε εδώ για ανέβασμα",
  "account_edit.upload_modal.step_upload.header": "Επιλέξτε μια εικόνα",
  "account_edit.upload_modal.step_upload.hint": "WEBP, PNG, GIF ή JPG μορφή, μέχρι {limit}MB.{br}Η ανάλυση της εικόνας θα προσαρμοστεί στα {width}x{height}px.",
  "account_edit.upload_modal.title_add.avatar": "Προσθήκη εικόνας προφίλ",
  "account_edit.upload_modal.title_add.header": "Προσθήκη εικόνας εξωφύλλου",
  "account_edit.upload_modal.title_replace.avatar": "Αντικατάσταση εικόνας προφίλ",
  "account_edit.upload_modal.title_replace.header": "Αντικατάσταση εικόνας εξωφύλλου",
  "account_edit.verified_modal.details": "Πρόσθεσε αξιοπιστία στο Mastodon προφίλ σου επαληθεύοντας συνδέσμους προς προσωπικές ιστοσελίδες. Ορίστε πως δουλεύει:",
  "account_edit.verified_modal.invisible_link.details": "Πρόσθεσε τον σύνδεσμο στην κεφαλίδα σου. Το σημαντικό μέρος είναι το rel=\"me\" που αποτρέπει την μίμηση σε ιστοσελίδες με περιεχόμενο παραγόμενο από χρήστες. Μπορείς ακόμα να χρησιμοποιήσεις μια ετικέτα link στην κεφαλίδα της σελίδας αντί για {tag}, αλλά η HTML πρέπει να είναι προσβάσιμη χωρίς την εκτέλεση JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "Πώς κάνω αυτόν τον σύνδεσμο αόρατο;",
  "account_edit.verified_modal.step1.header": "Αντίγραψε τον παρακάτω κώδικα HTML και επικόλλησε τον στην κεφαλίδα της ιστοσελίδας σου",
  "account_edit.verified_modal.step2.details": "Αν έχεις ήδη προσθέσει τον ιστότοπό σου ως προσαρμοσμένο πεδίο, θα χρειαστεί να τον διαγράψεις και να τον προσθέσεις ξανά για να ενεργοποιηθεί η επαλήθευση.",
  "account_edit.verified_modal.step2.header": "Πρόσθεσε την ιστοσελίδα σου ως προσαρμοσμένο πεδίο",
  "account_edit.verified_modal.title": "Πώς να προσθέσεις έναν επαληθευμένο σύνδεσμο",
  "account_edit_tags.add_tag": "Προσθήκη #{tagName}",
  "account_edit_tags.column_title": "Επεξεργασία Ετικετών",
  "account_edit_tags.help_text": "Οι αναδεδειγμένες ετικέτες βοηθούν τους χρήστες να ανακαλύψουν και να αλληλεπιδράσουν με το προφίλ σας. Εμφανίζονται ως φίλτρα στην καρτέλα Δραστηριότητα της σελίδας προφίλ σας.",
  "account_edit_tags.max_tags_reached": "Έχετε φτάσει τον μέγιστο αριθμό των προτεινόμενων ετικετών.",
  "account_edit_tags.search_placeholder": "Εισάγετε μια ετικέτα…",
  "account_edit_tags.suggestions": "Προτάσεις:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# ανάρτηση} other {# αναρτήσεις}}",
  "account_list.hidden_notice": "Αυτό είναι ορατό μόνο σε εσάς. Για να εμφανίσετε αυτή τη λίστα σε άλλους, πηγαίνετε στο <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# λογαριασμός} other {# λογαριασμοί}}",
  "account_note.placeholder": "Κάνε κλικ για να προσθέσεις σημείωση",
  "admin.dashboard.daily_retention": "Ποσοστό χρηστών που παραμένουν μετά την εγγραφή, ανά ημέρα",
  "admin.dashboard.monthly_retention": "Ποσοστό χρηστών που παραμένουν μετά την εγγραφή, ανά μήνα",
  "admin.dashboard.retention.average": "Μέσος όρος",
  "admin.dashboard.retention.cohort": "Μήνας εγγραφής",
  "admin.dashboard.retention.cohort_size": "Νέοι χρήστες",
  "admin.impact_report.instance_accounts": "Προφίλ λογαριασμών που θα διαγράψει",
  "admin.impact_report.instance_followers": "Ακόλουθοι που θα χάσουν οι χρήστες μας",
  "admin.impact_report.instance_follows": "Ακόλουθοι που θα χάσουν οι χρήστες τους",
  "admin.impact_report.title": "Περίληψη επιπτώσεων",
  "alert.rate_limited.message": "Παρακαλούμε δοκίμασε ξανά μετά τις {retry_time, time, medium}",
  "alert.rate_limited.title": "Περιορισμός συχνότητας",
  "alert.unexpected.message": "Προέκυψε απροσδόκητο σφάλμα.",
  "alert.unexpected.title": "Ουπς!",
  "alt_text_badge.title": "Εναλλακτικό κείμενο",
  "alt_text_modal.add_alt_text": "Προσθήκη εναλλακτικού κειμένου",
  "alt_text_modal.add_text_from_image": "Προσθήκη κειμένου από εικόνα",
  "alt_text_modal.cancel": "Ακύρωση",
  "alt_text_modal.change_thumbnail": "Αλλαγή μικρογραφίας",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Περιέγραψε αυτό για άτομα με προβλήματα ακοής…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Περιέγραψε αυτό για άτομα με προβλήματα όρασης…",
  "alt_text_modal.done": "Τέλος",
  "announcement.announcement": "Ανακοίνωση",
  "annual_report.announcement.action_build": "Φτιάξε το Wrapstodon μου",
  "annual_report.announcement.action_dismiss": "Όχι, ευχαριστώ",
  "annual_report.announcement.action_view": "Προβολή του Wrapstodon μου",
  "annual_report.announcement.description": "Ανακαλύψτε περισσότερα για την αλληλεπίδραση σας στο Mastodon κατά τη διάρκεια του περασμένου έτους.",
  "annual_report.announcement.title": "Το Wrapstodon του {year} έφτασε",
  "annual_report.nav_item.badge": "Νέο",
  "annual_report.shared_page.donate": "Δωρεά",
  "annual_report.shared_page.footer": "Παράχθηκε με {heart} από την ομάδα του Mastodon",
  "annual_report.shared_page.footer_server_info": "Ο/Η {username} χρησιμοποιεί το {domain}, μία από τις πολλές κοινότητες που βασίζονται στο Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "Ο/Η {name} έμεινε στο κυνήγι για αναρτήσεις για να τις ενισχύσει, ενισχύοντας άλλους δημιουργούς με τέλειο στόχο.",
  "annual_report.summary.archetype.booster.desc_self": "Έμεινες στο κυνήγι για αναρτήσεις για να τις ενισχύσεις, ενισχύοντας άλλους δημιουργούς με τέλειο στόχο.",
  "annual_report.summary.archetype.booster.name": "Ο Τοξότης",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Ξέρουμε ότι ο/η {name} ήταν εκεί έξω, κάπου, απολαμβάνοντας το Mastodon με τον δικό του/της ήσυχο τρόπο.",
  "annual_report.summary.archetype.lurker.desc_self": "Ξέρουμε ότι ήσουν εκεί έξω, κάπου, απολαμβάνοντας το Mastodon με τον δικό σου ήσυχο τρόπο.",
  "annual_report.summary.archetype.lurker.name": "Ο Στωϊκός",
  "annual_report.summary.archetype.oracle.desc_public": "O/H {name} δημιούργησε νέες αναρτήσεις περισσότερο από ότι απαντήσεις, κρατώντας το Mastodon φρέσκο και κοιτώντας προς το μέλλον.",
  "annual_report.summary.archetype.oracle.desc_self": "Δημιούργησες νέες αναρτήσεις περισσότερο από ότι απαντήσεις, κρατώντας το Mastodon φρέσκο και κοιτώντας προς το μέλλον.",
  "annual_report.summary.archetype.oracle.name": "Η Πυθία",
  "annual_report.summary.archetype.pollster.desc_public": "Ο/Η {name} δημιούργησε περισσότερες δημοσκοπήσεις από άλλα είδη αναρτήσεων, καλλιεργώντας περιέργεια στο Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Δημιούργησες περισσότερες δημοσκοπήσεις από άλλα είδη αναρτήσεων, καλλιεργώντας περιέργεια στο Mastodon.",
  "annual_report.summary.archetype.pollster.name": "Ο Θαυμαστής",
  "annual_report.summary.archetype.replier.desc_public": "Ο/Η {name} συχνά απαντούσε σε αναρτήσεις άλλων ανθρώπων, επικονίαζοντας το Mastodon με νέες συζητήσεις.",
  "annual_report.summary.archetype.replier.desc_self": "Συχνά απαντούσες σε αναρτήσεις άλλων ανθρώπων, επικονίαζοντας το Mastodon με νέες συζητήσεις.",
  "annual_report.summary.archetype.replier.name": "Η Πεταλούδα",
  "annual_report.summary.archetype.reveal": "Αποκάλυψε το αρχέτυπο μου",
  "annual_report.summary.archetype.reveal_description": "Ευχαριστούμε που είσαι μέρος του Mastodon! Ώρα να μάθεις ποιο αρχέτυπο έχεις ενσαρκώσει το {year}.",
  "annual_report.summary.archetype.title_public": "Αρχέτυπο του/της {name}",
  "annual_report.summary.archetype.title_self": "Το αρχέτυπο σου",
  "annual_report.summary.close": "Κλείσιμο",
  "annual_report.summary.copy_link": "Αντιγραφή συνδέσμου",
  "annual_report.summary.followers.new_followers": "{count, plural, one {νέος ακόλουθος} other {νέοι ακόλουθοι}}",
  "annual_report.summary.highlighted_post.boost_count": "Αυτή η ανάρτηση ενισχύθηκε {count, plural, one {μια φορά} other {# φορές}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Αυτή η ανάρτηση αγαπήθηκε {count, plural, one {μια φορά} other {# φορές}}.",
  "annual_report.summary.highlighted_post.reply_count": "Αυτή η ανάρτηση πήρε {count, plural, one {μια απάντηση} other {# απαντήσεις}}.",
  "annual_report.summary.highlighted_post.title": "Πιο δημοφιλής ανάρτηση",
  "annual_report.summary.most_used_app.most_used_app": "πιο χρησιμοποιημένη εφαρμογή",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "πιο χρησιμοποιημένη ετικέτα",
  "annual_report.summary.most_used_hashtag.used_count": "Έχεις συμπεριλάβει αυτήν την ετικέτα σε {count, plural, one {μια ανάρτηση} other {# αναρτήσεις}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "Ο/Η {name} έχει συμπεριλάβει αυτήν την ετικέτα σε {count, plural, one {μια ανάρτηση} other {# αναρτήσεις}}.",
  "annual_report.summary.new_posts.new_posts": "νέες αναρτήσεις",
  "annual_report.summary.percentile.text": "<topLabel>Αυτό σε βάζει στο </topLabel><percentage></percentage><bottomLabel>των κορυφαίων χρηστών του {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Δεν θα το πούμε στον Bernie.",
  "annual_report.summary.share_elsewhere": "Κοινοποίηση αλλού",
  "annual_report.summary.share_message": "Πήρα το αρχέτυπο {archetype}!",
  "annual_report.summary.share_on_mastodon": "Κοινοποίηση στο Mastodon",
  "attachments_list.unprocessed": "(μη επεξεργασμένο)",
  "audio.hide": "Απόκρυψη αρχείου ήχου",
  "block_modal.no_collections": "Κανένας από τους δύο σας δεν μπορεί να προσθέσει ο ένας τον άλλο σε συλλογές. Θα αφαιρεθεί αυτόματα ο ένας από τις υπάρχουσες συλλογές του άλλου, αν υπάρχουν.",
  "block_modal.remote_users_caveat": "Θα ζητήσουμε από τον διακομιστή {domain} να σεβαστεί την απόφασή σου. Ωστόσο, η συμμόρφωση δεν είναι εγγυημένη δεδομένου ότι ορισμένοι διακομιστές ενδέχεται να χειρίζονται τους αποκλεισμούς διαφορετικά. Οι δημόσιες αναρτήσεις ενδέχεται να είναι ορατές σε μη συνδεδεμένους χρήστες.",
  "block_modal.show_less": "Εμφάνιση λιγότερων",
  "block_modal.show_more": "Εμφάνιση περισσότερων",
  "block_modal.they_cant_mention": "Δεν μπορείτε να επισημάνετε, να ακολουθήσετε ή να παραθέσετε ο ένας τον άλλον.",
  "block_modal.they_cant_see_posts": "Δεν μπορεί να δει το περιεχόμενό σου και δε θα δεις το δικό του.",
  "block_modal.they_will_know": "Μπορούν να δει ότι έχει αποκλειστεί.",
  "block_modal.title": "Αποκλεισμός χρήστη;",
  "block_modal.you_wont_see_mentions": "Δε θα βλέπεις τις αναρτήσεις από άλλους που τον επισημαίνουν.",
  "boost_modal.combo": "Μπορείς να πατήσεις {combo} για να το προσπεράσεις την επόμενη φορά",
  "boost_modal.reblog": "Ενίσχυση ανάρτησης;",
  "boost_modal.undo_reblog": "Αναίρεση ενίσχυσης;",
  "bundle_column_error.copy_stacktrace": "Αντιγραφή αναφοράς σφάλματος",
  "bundle_column_error.error.body": "Δεν ήταν δυνατή η απόδοση της σελίδας που ζήτησες. Μπορεί να οφείλεται σε σφάλμα στον κώδικά μας ή σε πρόβλημα συμβατότητας του προγράμματος περιήγησης.",
  "bundle_column_error.error.title": "Ωχ όχι!",
  "bundle_column_error.network.body": "Παρουσιάστηκε σφάλμα κατά την προσπάθεια φόρτωσης αυτής της σελίδας. Αυτό θα μπορούσε να οφείλεται σε ένα προσωρινό πρόβλημα με τη σύνδεσή σου στο διαδίκτυο ή σε αυτόν τον διακομιστή.",
  "bundle_column_error.network.title": "Σφάλμα δικτύου",
  "bundle_column_error.retry": "Δοκίμασε ξανά",
  "bundle_column_error.return": "Μετάβαση πίσω στην αρχική σελίδα",
  "bundle_column_error.routing.body": "Η επιθυμητή σελίδα δεν βρέθηκε. Είναι σωστό το URL στο πεδίο διευθύνσεων;",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Κλείσιμο",
  "bundle_modal_error.message": "Κάτι πήγε στραβά κατά τη φόρτωση αυτής της οθόνης.",
  "bundle_modal_error.retry": "Δοκίμασε ξανά",
  "callout.dismiss": "Παράβλεψη",
  "carousel.current": "<sr>Διαφάνεια</sr> {current, number} / {max, number}",
  "carousel.slide": "Διαφάνεια {current, number} από {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} προτεινόμενοι χαρακτήρες",
  "character_counter.required": "{currentLength}/{maxLength} χαρακτήρες",
  "closed_registrations.other_server_instructions": "Καθώς το Mastodon είναι αποκεντρωμένο, μπορείς να δημιουργήσεις λογαριασμό σε άλλον διακομιστή αλλά να συνεχίσεις να αλληλεπιδράς με αυτόν.",
  "closed_registrations_modal.description": "Η δημιουργία λογαριασμού στον {domain} προς το παρόν δεν είναι δυνατή, αλλά λάβε υπόψη ότι δεν χρειάζεσαι λογαριασμό ειδικά στον {domain} για να χρησιμοποιήσεις το Mastodon.",
  "closed_registrations_modal.find_another_server": "Βρες άλλον διακομιστή",
  "closed_registrations_modal.preamble": "Το Mastodon είναι αποκεντρωμένο, οπότε ανεξάρτητα από το πού θα δημιουργήσεις τον λογαριασμό σου, μπορείς να ακολουθήσεις και να αλληλεπιδράσεις με οποιονδήποτε σε αυτόν τον διακομιστή. Μπορείς ακόμη και να κάνεις τον δικό σου!",
  "closed_registrations_modal.title": "Εγγραφή στο Mastodon",
  "collection.share_modal.share_link_label": "Κοινοποίηση συνδέσμου",
  "collection.share_modal.share_via_post": "Ανάρτηση στο Mastodon",
  "collection.share_modal.share_via_system": "Κοινοποίηση σε…",
  "collection.share_modal.title": "Κοινοποίηση συλλογής",
  "collection.share_modal.title_new": "Μοιραστείτε τη νέα σας συλλογή!",
  "collection.share_template_other": "Δείτε αυτή την ωραία συλλογή: {link}",
  "collection.share_template_own": "Δείτε τη νέα μου συλλογή: {link}",
  "collections.account_count": "{count, plural, one {# λογαριασμός} other {# λογαριασμοί}}",
  "collections.accounts.empty_description": "Προσθέστε μέχρι και {count} λογαριασμούς",
  "collections.accounts.empty_editor_title": "Κανείς δεν είναι ακόμη σε αυτήν τη συλλογή",
  "collections.accounts.empty_title": "Αυτή η συλλογή είναι κενή",
  "collections.block_collection_owner": "Αποκλεισμός λογαριασμού",
  "collections.by_account": "από {account_handle}",
  "collections.collection_description": "Περιγραφή",
  "collections.collection_language": "Γλώσσα",
  "collections.collection_language_none": "Καμία",
  "collections.collection_name": "Όνομα",
  "collections.collection_topic": "Θέμα",
  "collections.confirm_account_removal": "Σίγουρα θέλετε να αφαιρέσετε αυτόν τον λογαριασμό από αυτή τη συλλογή;",
  "collections.content_warning": "Προειδοποίηση περιεχομένου",
  "collections.continue": "Συνέχεια",
  "collections.copy_link": "Αντιγραφή συνδέσμου",
  "collections.copy_link_confirmation": "Αντιγράφηκε ο σύνδεσμος συλλογής στο πρόχειρο",
  "collections.create.accounts_title": "Ποιον θα αναδείξετε σε αυτήν τη συλλογή;",
  "collections.create.basic_details_title": "Βασικά στοιχεία",
  "collections.create.steps": "Βήμα {step}/{total}",
  "collections.create_collection": "Δημιουργία συλλογής",
  "collections.delete_collection": "Διαγραφή συλλογής",
  "collections.description_length_hint": "Όριο 100 χαρακτήρων",
  "collections.detail.author_added_you_on_date": "Ο χρήστης {author} σας πρόσθεσε στις {date}",
  "collections.detail.loading": "Γίνεται φόρτωση της συλλογής…",
  "collections.detail.revoke_inclusion": "Αφαίρεσε με",
  "collections.detail.sensitive_content": "Ευαίσθητο περιεχόμενο",
  "collections.detail.sensitive_note": "Αυτή η συλλογή περιέχει λογαριασμούς και περιεχόμενο που μπορεί να είναι ευαίσθητα σε ορισμένους χρήστες.",
  "collections.detail.share": "Κοινοποιήστε αυτήν τη συλλογή",
  "collections.detail.you_are_in_this_collection": "Είστε αναδεδειγμένοι σε αυτήν τη συλλογή",
  "collections.edit_details": "Επεξεργασία λεπτομερειών",
  "collections.error_loading_collections": "Παρουσιάστηκε σφάλμα κατά την προσπάθεια φόρτωσης αυτών των συλλογών.",
  "collections.hidden_accounts_description": "Έχετε αποκλείσει ή κάνει σίγαση {count, plural, one {αυτόν τον χρήστη} other {αυτούς τους χρήστες}}",
  "collections.hidden_accounts_link": "{count, plural, one {# κρυμμένος λογαριασμός} other {# κρυμμένοι λογαριασμοί}}",
  "collections.hints.accounts_counter": "{count}/{max} λογαριασμοί",
  "collections.last_updated_at": "Τελευταία ενημέρωση: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# Συλλογή} other {# Συλλογές}}",
  "collections.list.created_by_author": "Δημιουργήθηκε από {name}",
  "collections.list.created_by_you": "Δημιουργήθηκε από εσάς",
  "collections.list.featuring_you": "Σας αναδεικνύει",
  "collections.manage_accounts": "Διαχείριση λογαριασμών",
  "collections.mark_as_sensitive": "Σήμανση ως ευαίσθητο",
  "collections.mark_as_sensitive_hint": "Κρύβει την περιγραφή και τους λογαριασμούς της συλλογής πίσω από μια προειδοποίηση περιεχομένου. Το όνομα της συλλογής θα είναι ακόμη ορατό.",
  "collections.maximum_collection_count_description": "Ο εξυπηρετητής σου επιτρέπει την δημιουργία μέχρι {count} συλλογών.",
  "collections.maximum_collection_count_reached": "Έχεις δημιουργήσει τον μέγιστο αριθμό συλλογών",
  "collections.name_length_hint": "Όριο 40 χαρακτήρων",
  "collections.new_collection": "Νέα συλλογή",
  "collections.pending_accounts.message": "Οι λογαριασμοί μπορεί να εμφανίζονται ως εκκρεμείς όταν περιμένουμε απάντηση από τον χρήστη ή τον διακομιστή τους. Μόνο εσείς μπορείτε να δείτε εκκρεμείς λογαριασμούς.",
  "collections.pending_accounts.title": "Γιατί βλέπω εκκρεμείς λογαριασμούς;",
  "collections.remove_account": "Αφαίρεση",
  "collections.report_collection": "Αναφορά αυτής της συλλογής",
  "collections.revoke_collection_inclusion": "Αφαίρεσε τον εαυτό μου από αυτήν τη συλλογή",
  "collections.revoke_inclusion.confirmation": "Έχεις αφαιρεθεί από τη συλλογή \"{collection}\"",
  "collections.revoke_inclusion.error": "Υπήρξε ένα σφάλμα, παρακαλούμε προσπαθήστε ξανά αργότερα.",
  "collections.search_accounts_label": "Αναζήτηση λογαριασμού για προσθήκη",
  "collections.search_accounts_max_reached": "Έχετε προσθέσει τον μέγιστο αριθμό λογαριασμών",
  "collections.sensitive": "Ευαίσθητο",
  "collections.share_short": "Κοινοποίηση",
  "collections.suggestions.can_not_add": "Δεν μπορεί να προστεθεί",
  "collections.suggestions.can_not_add_desc": "Αυτοί οι λογαριασμοί μπορεί να έχουν εξαιρεθεί από την ανακάλυψη, ή μπορεί να είναι σε έναν διακομιστή που δεν υποστηρίζει συλλογές.",
  "collections.suggestions.must_follow": "Πρέπει να τον ακολουθήσετε πρώτα",
  "collections.suggestions.must_follow_desc": "Αυτοί οι λογαριασμοί ελέγχουν όλα τα αιτήματα ακολούθησης. Οι ακόλουθοι μπορούν να τους προσθέσουν στις συλλογές.",
  "collections.topic_hint": "Προσθέστε μια ετικέτα που βοηθά άλλους να κατανοήσουν το κύριο θέμα αυτής της συλλογής.",
  "collections.topic_special_chars_hint": "Οι ειδικοί χαρακτήρες θα αφαιρεθούν κατά την αποθήκευση",
  "collections.unlisted_collections_description": "Αυτές δεν εμφανίζονται στο προφίλ σας σε άλλους. Οποιοσδήποτε με τον σύνδεσμο μπορεί να τις ανακαλύψει.",
  "collections.unlisted_collections_with_count": "Μη καταχωρισμένες συλλογές ({count})",
  "collections.view_collection": "Προβολή συλλογής",
  "collections.visibility_public": "Δημόσια",
  "collections.visibility_public_hint": "Ανιχνεύσιμη στα αποτελέσματα αναζήτησης και σε άλλα σημεία όπου εμφανίζονται προτάσεις.",
  "collections.visibility_title": "Ορατότητα",
  "collections.visibility_unlisted": "Μη καταχωρημένη",
  "collections.visibility_unlisted_hint": "Ορατή σε οποιονδήποτε με σύνδεσμο. Κρυμμένη από τα αποτελέσματα αναζήτησης και τις προτάσεις.",
  "column.about": "Σχετικά με",
  "column.blocks": "Αποκλεισμένοι χρήστες",
  "column.bookmarks": "Σελιδοδείκτες",
  "column.community": "Τοπική ροή",
  "column.create_list": "Δημιουργία λίστας",
  "column.direct": "Ιδιωτικές επισημάνσεις",
  "column.directory": "Περιήγηση στα προφίλ",
  "column.domain_blocks": "Αποκλεισμένοι τομείς",
  "column.edit_list": "Επεξεργασία λίστας",
  "column.favourites": "Αγαπημένα",
  "column.firehose": "Ζωντανές ροές",
  "column.firehose_local": "Ζωντανή ροή για αυτόν τον διακομιστή",
  "column.firehose_singular": "Ζωντανή ροή",
  "column.follow_requests": "Αιτήματα ακολούθησης",
  "column.home": "Αρχική",
  "column.list_members": "Διαχείριση μελών λίστας",
  "column.lists": "Λίστες",
  "column.mutes": "Αποσιωπημένοι χρήστες",
  "column.notifications": "Ειδοποιήσεις",
  "column.other_collections": "Συλλογές από {name}",
  "column.pins": "Καρφιτσωμένες αναρτήσεις",
  "column.public": "Ομοσπονδιακή ροή",
  "column.your_collections": "Οι Συλλογές σας",
  "column_back_button.label": "Πίσω",
  "column_header.hide_settings": "Απόκρυψη ρυθμίσεων",
  "column_header.moveLeft_settings": "Μεταφορά στήλης στα αριστερά",
  "column_header.moveRight_settings": "Μεταφορά στήλης στα δεξιά",
  "column_header.pin": "Καρφίτσωμα",
  "column_header.show_settings": "Εμφάνιση ρυθμίσεων",
  "column_header.unpin": "Ξεκαρφίτσωμα",
  "column_search.cancel": "Ακύρωση",
  "combobox.close_results": "Κλείσιμο αποτελεσμάτων",
  "combobox.loading": "Γίνεται φόρτωση",
  "combobox.no_results_found": "Κανένα αποτέλεσμα για αυτήν την αναζήτηση",
  "combobox.open_results": "Άνοιγμα αποτελεσμάτων",
  "combobox.results_available": "{count, plural, one {# πρόταση διαθέσιμη} other {# προτάσεις διαθέσιμες}}. Χρησιμοποιήστε τα βελάκια πάνω και κάτω για να πλοηγηθείτε. Πατήστε Enter για να επιλέξετε.",
  "community.column_settings.local_only": "Τοπική μόνο",
  "community.column_settings.media_only": "Μόνο πολυμέσα",
  "community.column_settings.remote_only": "Απομακρυσμένα μόνο",
  "compose.error.blank_post": "Η ανάρτηση δεν μπορεί να είναι κενή.",
  "compose.language.change": "Αλλαγή γλώσσας",
  "compose.language.search": "Αναζήτηση γλωσσών...",
  "compose.published.body": "Η ανάρτηση δημοσιεύτηκε.",
  "compose.published.open": "Άνοιγμα",
  "compose.saved.body": "Η ανάρτηση αποθηκεύτηκε.",
  "compose_form.direct_message_warning_learn_more": "Μάθε περισσότερα",
  "compose_form.encryption_warning": "Οι αναρτήσεις στο Mastodon δεν είναι κρυπτογραφημένες από άκρο σε άκρο. Μη μοιράζεσαι ευαίσθητες πληροφορίες μέσω του Mastodon.",
  "compose_form.hashtag_warning": "Αυτή η ανάρτηση δεν θα εμφανίζεται κάτω από οποιαδήποτε ετικέτα καθώς δεν είναι δημόσια. Μόνο οι δημόσιες αναρτήσεις μπορούν να αναζητηθούν με ετικέτα.",
  "compose_form.lock_disclaimer": "Ο λογαριασμός σου δεν είναι {locked}. Οποιοσδήποτε μπορεί να σε ακολουθήσει για να δει τις μόνο για ακολούθους αναρτήσεις σου.",
  "compose_form.lock_disclaimer.lock": "κλειδωμένος",
  "compose_form.placeholder": "Τι σκέφτεσαι;",
  "compose_form.poll.duration": "Διάρκεια δημοσκόπησης",
  "compose_form.poll.multiple": "Πολλαπλή επιλογή",
  "compose_form.poll.option_placeholder": "Επιλογή {number}",
  "compose_form.poll.single": "Μονή επιλογή",
  "compose_form.poll.switch_to_multiple": "Ενημέρωση δημοσκόπησης με πολλαπλές επιλογές",
  "compose_form.poll.switch_to_single": "Ενημέρωση δημοσκόπησης με μοναδική επιλογή",
  "compose_form.poll.type": "Στυλ",
  "compose_form.publish": "Ανάρτηση",
  "compose_form.reply": "Απάντηση",
  "compose_form.save_changes": "Ενημέρωση",
  "compose_form.spoiler.marked": "Αφαίρεση προειδοποίηση περιεχομένου",
  "compose_form.spoiler.unmarked": "Προσθήκη προειδοποίησης περιεχομένου",
  "compose_form.spoiler_placeholder": "Προειδοποίηση περιεχομένου (προαιρετική)",
  "confirmation_modal.cancel": "Άκυρο",
  "confirmations.block.confirm": "Αποκλεισμός",
  "confirmations.delete.confirm": "Διαγραφή",
  "confirmations.delete.message": "Σίγουρα θες να διαγράψεις αυτήν την ανάρτηση;",
  "confirmations.delete.title": "Διαγραφή ανάρτησης;",
  "confirmations.delete_collection.confirm": "Διαγραφή",
  "confirmations.delete_collection.message": "Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
  "confirmations.delete_collection.title": "Διαγραφή \"{name}\";",
  "confirmations.delete_list.confirm": "Διαγραφή",
  "confirmations.delete_list.message": "Σίγουρα θες να διαγράψεις οριστικά αυτή τη λίστα;",
  "confirmations.delete_list.title": "Διαγραφή λίστας;",
  "confirmations.discard_draft.confirm": "Απόρριψη και συνέχεια",
  "confirmations.discard_draft.edit.cancel": "Συνέχιση επεξεργασίας",
  "confirmations.discard_draft.edit.message": "Συνεχίζοντας θα απορρίψει τυχόν αλλαγές που έχετε κάνει στην ανάρτηση που επεξεργάζεστε.",
  "confirmations.discard_draft.edit.title": "Απόρριψη αλλαγών στην ανάρτηση σας;",
  "confirmations.discard_draft.post.cancel": "Συνέχιση προχείρου",
  "confirmations.discard_draft.post.message": "Συνεχίζοντας θα απορρίψει την ανάρτηση που συνθέτετε.",
  "confirmations.discard_draft.post.title": "Απόρριψη της πρόχειρης ανάρτησης σας;",
  "confirmations.discard_edit_media.confirm": "Απόρριψη",
  "confirmations.discard_edit_media.message": "Έχεις μη αποθηκευμένες αλλαγές στην περιγραφή πολυμέσων ή στην προεπισκόπηση, απόρριψη ούτως ή άλλως;",
  "confirmations.follow_to_list.confirm": "Ακολούθησε και πρόσθεσε στη λίστα",
  "confirmations.follow_to_list.message": "Πρέπει να ακολουθήσεις τον χρήστη {name} για να τον προσθέσεις σε μια λίστα.",
  "confirmations.follow_to_list.title": "Ακολούθηση χρήστη;",
  "confirmations.hide_featured_tab.confirm": "Απόκρυψη καρτέλας",
  "confirmations.hide_featured_tab.intro": "Μπορείτε να το αλλάξετε ανά πάσα στιγμή κάτω από το <i>Επεξεργασία προφίλ> Ρυθμίσεις καρτελών προφίλ</i>.",
  "confirmations.hide_featured_tab.message": "Αυτό θα κρύψει την καρτέλα για τους χρήστες στο {serverName} και σε άλλους διακομιστές που εκτελούν την τελευταία έκδοση του Mastodon. Άλλες εμφανίσεις μπορεί να ποικίλλουν.",
  "confirmations.hide_featured_tab.title": "Απόκρυψη καρτέλας \"Αναδεδειγμένα\";",
  "confirmations.logout.confirm": "Αποσύνδεση",
  "confirmations.logout.message": "Σίγουρα θέλεις να αποσυνδεθείς;",
  "confirmations.logout.title": "Αποσύνδεση;",
  "confirmations.missing_alt_text.confirm": "Προσθήκη εναλλακτικού κειμένου",
  "confirmations.missing_alt_text.message": "Η ανάρτησή σου περιέχει πολυμέσα χωρίς εναλλακτικό κείμενο. Η προσθήκη περιγραφών βοηθά να γίνει το περιεχόμενό σου προσβάσιμο σε περισσότερους ανθρώπους.",
  "confirmations.missing_alt_text.secondary": "Δημοσίευση όπως και να ΄χει",
  "confirmations.missing_alt_text.title": "Προσθήκη εναλλακτικού κειμένου;",
  "confirmations.mute.confirm": "Σίγαση",
  "confirmations.private_quote_notify.cancel": "Πίσω στην επεξεργασία",
  "confirmations.private_quote_notify.confirm": "Δημοσίευση ανάρτησης",
  "confirmations.private_quote_notify.do_not_show_again": "Να μην εμφανιστεί ξανά αυτό το μήνυμα",
  "confirmations.private_quote_notify.message": "Το άτομο που παραθέτετε και άλλες επισημάνσεις θα ειδοποιηθούν και θα μπορούν να δουν την ανάρτησή σας, ακόμη και αν δεν σας ακολουθούν.",
  "confirmations.private_quote_notify.title": "Κοινοποίηση με τους ακολούθους και τους επισημασμένους χρήστες;",
  "confirmations.quiet_post_quote_info.dismiss": "Μη μου το ξαναθυμίσεις",
  "confirmations.quiet_post_quote_info.got_it": "Το κατάλαβα",
  "confirmations.quiet_post_quote_info.message": "Όταν παραθέτετε μια ήσυχη δημόσια ανάρτηση, η ανάρτηση σας θα είναι κρυμμένη από τις δημοφιλείς ροές.",
  "confirmations.quiet_post_quote_info.title": "Παράθεση ήσυχων δημόσιων αναρτήσεων",
  "confirmations.redraft.confirm": "Διαγραφή & ξαναγράψιμο",
  "confirmations.redraft.message": "Σίγουρα θέλεις να σβήσεις αυτή την ανάρτηση και να την ξαναγράψεις; Οι προτιμήσεις και προωθήσεις θα χαθούν και οι απαντήσεις στην αρχική ανάρτηση θα μείνουν ορφανές.",
  "confirmations.redraft.title": "Διαγραφή & επανασύνταξη;",
  "confirmations.remove_from_followers.confirm": "Αφαίρεση ακολούθου",
  "confirmations.remove_from_followers.message": "Ο χρήστης {name} θα σταματήσει να σε ακολουθεί. Σίγουρα θες να συνεχίσεις;",
  "confirmations.remove_from_followers.title": "Αφαίρεση ακολούθου;",
  "confirmations.revoke_collection_inclusion.confirm": "Αφαίρεσε με",
  "confirmations.revoke_collection_inclusion.message": "Αυτή η ενέργεια είναι μόνιμη, και ο επιμελητής δεν θα μπορεί να σε προσθέσει ξανά στη συλλογή αργότερα.",
  "confirmations.revoke_collection_inclusion.title": "Αφαίρεσε τον εαυτό σου από αυτήν τη συλλογή;",
  "confirmations.revoke_quote.confirm": "Αφαίρεση ανάρτησης",
  "confirmations.revoke_quote.message": "Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
  "confirmations.revoke_quote.title": "Αφαίρεση ανάρτησης;",
  "confirmations.unblock.confirm": "Άρση αποκλεισμού",
  "confirmations.unblock.title": "Άρση αποκλεισμού {name};",
  "confirmations.unfollow.confirm": "Άρση ακολούθησης",
  "confirmations.unfollow.title": "Άρση ακολούθησης του/της {name};",
  "confirmations.withdraw_request.confirm": "Απόσυρση αιτήματος",
  "confirmations.withdraw_request.title": "Απόσυρση αιτήματος για να ακολουθήσετε τον/την {name};",
  "content_warning.hide": "Απόκρυψη ανάρτησης",
  "content_warning.show": "Εμφάνιση ούτως ή άλλως",
  "content_warning.show_more": "Εμφάνιση περισσότερων",
  "content_warning.show_short": "Εμφάνιση",
  "conversation.delete": "Διαγραφή συνομιλίας",
  "conversation.mark_as_read": "Σήμανση ως αναγνωσμένη",
  "conversation.open": "Προβολή συνομιλίας",
  "conversation.with": "Με {names}",
  "copy_icon_button.copied": "Αντιγράφηκε στο πρόχειρο",
  "copy_icon_button.copy_this_text": "Αντιγραφή συνδέσμου στο πρόχειρο",
  "copypaste.copied": "Αντιγράφηκε",
  "copypaste.copy_to_clipboard": "Αντιγραφή στο πρόχειρο",
  "directory.federated": "Από το γνωστό fediverse",
  "directory.local": "Μόνο από {domain}",
  "directory.new_arrivals": "Νέες αφίξεις",
  "directory.recently_active": "Πρόσφατα ενεργοί",
  "disabled_account_banner.account_settings": "Ρυθμίσεις λογαριασμού",
  "disabled_account_banner.text": "Ο λογαριασμός σου {disabledAccount} είναι προς το παρόν απενεργοποιημένος.",
  "dismissable_banner.community_timeline": "Αυτές είναι οι πιο πρόσφατες δημόσιες αναρτήσεις ατόμων των οποίων οι λογαριασμοί φιλοξενούνται στο {domain}.",
  "dismissable_banner.dismiss": "Παράβλεψη",
  "dismissable_banner.public_timeline": "Αυτές είναι οι πιο πρόσφατες δημόσιες αναρτήσεις από άτομα στο fediverse που ακολουθούνται από άτομα του {domain}.",
  "domain_block_modal.block": "Αποκλεισμός διακομιστή",
  "domain_block_modal.block_account_instead": "Αποκλεισμός @{name} αντ' αυτού",
  "domain_block_modal.they_can_interact_with_old_posts": "Άτομα από αυτόν τον διακομιστή μπορούν να αλληλεπιδράσουν με τις παλιές αναρτήσεις σου.",
  "domain_block_modal.they_cant_follow": "Κανείς από αυτόν τον διακομιστή δεν μπορεί να σε ακολουθήσει.",
  "domain_block_modal.they_wont_know": "Δεν θα ξέρουν ότι έχουν αποκλειστεί.",
  "domain_block_modal.title": "Αποκλεισμός τομέα;",
  "domain_block_modal.you_will_lose_num_followers": "Θα χάσετε {followersCount, plural, one {{followersCountDisplay} ακόλουθο} other {{followersCountDisplay} ακόλουθους}} και {followingCount, plural, one {{followingCountDisplay} άτομο που ακολουθείτε} other {{followingCountDisplay} άτομα που ακολουθείτε}}.",
  "domain_block_modal.you_will_lose_relationships": "Θα χάσετε όλους τους ακόλουθους και τα άτομα που ακολουθείτε από αυτόν τον διακομιστή.",
  "domain_block_modal.you_wont_see_posts": "Δεν θα βλέπεις αναρτήσεις ή ειδοποιήσεις από χρήστες σε αυτόν το διακομιστή.",
  "domain_pill.activitypub_lets_connect": "Σου επιτρέπει να συνδεθείς και να αλληλεπιδράσεις με τους ανθρώπους όχι μόνο στο Mastodon, αλλά και σε διαφορετικές κοινωνικές εφαρμογές.",
  "domain_pill.activitypub_like_language": "Το ActivityPub είναι σαν τη γλώσσα Mastodon μιλάει με άλλα κοινωνικά δίκτυα.",
  "domain_pill.server": "Διακομιστής",
  "domain_pill.their_handle": "Το πλήρες όνομα χρήστη:",
  "domain_pill.their_server": "Το ψηφιακό του σπίτι, όπου ζουν όλες οι αναρτήσεις του.",
  "domain_pill.their_username": "Το μοναδικό του αναγνωριστικό στο διακομιστή του. Είναι πιθανό να βρεις χρήστες με το ίδιο όνομα χρήστη σε διαφορετικούς διακομιστές.",
  "domain_pill.username": "Όνομα χρήστη",
  "domain_pill.whats_in_a_handle": "Τί υπάρχει σε ένα πλήρες όνομα χρήστη;",
  "domain_pill.who_they_are": "Από τη στιγμή που τα πλήρη ονόματα χρηστών λένε ποιος είναι κάποιος και πού είναι, μπορείς να αλληλεπιδράσεις με άτομα απ' όλο τον κοινωνικό ιστό των <button>πλατφορμών που στηρίζονται στο ActivityPub</button>.",
  "domain_pill.who_you_are": "Επειδή το πλήρες όνομα χρήστη σου λέει ποιος είσαι και πού βρίσκεσαι, άτομα μπορούν να αλληλεπιδράσουν μαζί σου στον κοινωνικό ιστό των <button>πλατφορμών που στηρίζονται στο ActivityPub</button>.",
  "domain_pill.your_handle": "Το πλήρες όνομα χρήστη σου:",
  "domain_pill.your_server": "Το ψηφιακό σου σπίτι, όπου ζουν όλες σου οι αναρτήσεις. Δε σ' αρέσει αυτός; Μετακινήσου σε διακομιστές ανά πάσα στιγμή και πάρε και τους ακόλουθούς σου μαζί.",
  "domain_pill.your_username": "Το μοναδικό σου αναγνωριστικό σε τούτο τον διακομιστή. Είναι πιθανό να βρεις χρήστες με το ίδιο όνομα χρήστη σε διαφορετικούς διακομιστές.",
  "dropdown.empty": "Διαλέξτε μια επιλογή",
  "email_subscriptions.email": "Email",
  "email_subscriptions.form.action": "Εγγραφή",
  "email_subscriptions.form.bottom": "Λάβετε αναρτήσεις στα εισερχόμενά σας χωρίς να χρειαστεί να δημιουργήσετε λογαριασμό Mastodon. Κάντε απεγγραφή οποιαδήποτε στιγμή. Για περισσότερες πληροφορίες, ανατρέξτε στην <a>Πολιτική Απορρήτου</a>.",
  "email_subscriptions.form.title": "Εγγραφείτε για ενημερώσεις μέσω email από {name}",
  "email_subscriptions.submitted.lead": "Ελέγξτε τα εισερχόμενά σας για να ολοκληρωθεί η εγγραφή για ενημερώσεις μέσω email.",
  "email_subscriptions.submitted.title": "Ένα βήμα ακόμα",
  "email_subscriptions.validation.email.blocked": "Αποκλεισμένος πάροχος email",
  "email_subscriptions.validation.email.invalid": "Μη έγκυρη διεύθυνση email",
  "embed.instructions": "Ενσωμάτωσε αυτή την ανάρτηση στην ιστοσελίδα σου αντιγράφοντας τον παρακάτω κώδικα.",
  "embed.preview": "Ορίστε πως θα φαίνεται:",
  "emoji_button.activity": "Δραστηριότητα",
  "emoji_button.clear": "Καθαρισμός",
  "emoji_button.custom": "Προσαρμοσμένα",
  "emoji_button.flags": "Σημαίες",
  "emoji_button.food": "Φαγητά & Ποτά",
  "emoji_button.label": "Εισαγωγή emoji",
  "emoji_button.nature": "Φύση",
  "emoji_button.not_found": "Δε βρέθηκε αντιστοίχιση εμότζι",
  "emoji_button.objects": "Αντικείμενα",
  "emoji_button.people": "Άνθρωποι",
  "emoji_button.recent": "Χρησιμοποιούνται συχνά",
  "emoji_button.search": "Αναζήτηση...",
  "emoji_button.search_results": "Αποτελέσματα αναζήτησης",
  "emoji_button.symbols": "Σύμβολα",
  "emoji_button.travel": "Ταξίδια & Τοποθεσίες",
  "empty_column.account_featured.other": "Ο/Η {acct} δεν έχει αναδείξει τίποτα ακόμη.",
  "empty_column.account_featured_self.no_collections_button": "Δημιουργήστε μια συλλογή",
  "empty_column.account_featured_self.no_collections_hide_tab": "Απόκρυψη αυτής της καρτέλας αντ' αυτού",
  "empty_column.account_featured_self.pre_collections": "Μείνετε συντονισμένοι για τις Συλλογές",
  "empty_column.account_featured_self.pre_collections_desc": "Οι Συλλογές (που έρχονται στο Mastodon 4.6) επιτρέπουν να δημιουργήσετε τις δικές σας επιμελημένες λίστες λογαριασμών για να συστήσετε σε άλλους.",
  "empty_column.account_featured_self.showcase_accounts": "Παρουσιάστε τους αγαπημένους σας λογαριασμούς",
  "empty_column.account_featured_self.showcase_accounts_desc": "Οι συλλογές είναι επιμελημένες λίστες λογαριασμών για να βοηθήσουν άλλους να ανακαλύψουν περισσότερα από το Fediverse.",
  "empty_column.account_featured_unknown.other": "Αυτός ο λογαριασμός δεν έχει αναδείξει τίποτα ακόμη.",
  "empty_column.account_hides_collections": "Αυτός ο χρήστης έχει επιλέξει να μην καταστήσει αυτές τις πληροφορίες διαθέσιμες",
  "empty_column.account_suspended": "Λογαριασμός σε αναστολή",
  "empty_column.account_timeline": "Δεν έχει αναρτήσεις εδώ!",
  "empty_column.account_unavailable": "Μη διαθέσιμο προφίλ",
  "empty_column.blocks": "Δεν έχεις αποκλείσει κανέναν χρήστη ακόμη.",
  "empty_column.bookmarked_statuses": "Δεν έχεις καμία ανάρτηση με σελιδοδείκτη ακόμη. Μόλις βάλεις κάποιον, θα εμφανιστεί εδώ.",
  "empty_column.collections.featured_in": "Δεν έχετε προστεθεί ακόμη σε καμία συλλογή.",
  "empty_column.community": "Η τοπική ροή είναι κενή. Γράψε κάτι δημόσια για να αρχίσει να κυλά η μπάλα!",
  "empty_column.direct": "Δεν έχεις καμία ιδιωτική επισήμανση ακόμη. Όταν στείλεις ή λάβεις μία, θα εμφανιστεί εδώ.",
  "empty_column.disabled_feed": "Αυτή η ροή έχει απενεργοποιηθεί από τους διαχειριστές του διακομιστή σας.",
  "empty_column.domain_blocks": "Δεν υπάρχουν αποκλεισμένοι τομείς ακόμη.",
  "empty_column.explore_statuses": "Τίποτα δεν βρίσκεται στις τάσεις αυτή τη στιγμή. Έλεγξε αργότερα!",
  "empty_column.favourited_statuses": "Δεν έχεις καμία αγαπημένη ανάρτηση ακόμη. Μόλις αγαπήσεις κάποια, θα εμφανιστεί εδώ.",
  "empty_column.favourites": "Κανείς δεν έχει αγαπήσει αυτή την ανάρτηση ακόμη. Μόλις το κάνει κάποιος, θα εμφανιστεί εδώ.",
  "empty_column.follow_requests": "Δεν έχεις κανένα αίτημα παρακολούθησης ακόμη. Μόλις λάβεις κάποιο, θα εμφανιστεί εδώ.",
  "empty_column.followed_tags": "Δεν έχεις ακολουθήσει καμία ετικέτα ακόμη. Όταν το κάνεις, θα εμφανιστούν εδώ.",
  "empty_column.hashtag": "Δεν υπάρχει τίποτα σε αυτή την ετικέτα ακόμη.",
  "empty_column.home": "Η τοπική σου ροή είναι κενή! Πήγαινε στο {public} ή κάνε αναζήτηση για να ξεκινήσεις και να γνωρίσεις άλλους χρήστες.",
  "empty_column.list": "Δεν υπάρχει τίποτα σε αυτή τη λίστα ακόμη. Όταν τα μέλη της δημοσιεύσουν νέες αναρτήσεις, θα εμφανιστούν εδώ.",
  "empty_column.mutes": "Δεν έχεις κανένα χρήστη σε σίγαση ακόμη.",
  "empty_column.notification_requests": "Όλα καθαρά! Δεν υπάρχει τίποτα εδώ. Όταν λαμβάνεις νέες ειδοποιήσεις, αυτές θα εμφανίζονται εδώ σύμφωνα με τις ρυθμίσεις σου.",
  "empty_column.notifications": "Δεν έχεις ειδοποιήσεις ακόμη. Όταν άλλα άτομα αλληλεπιδράσουν μαζί σου, θα το δεις εδώ.",
  "empty_column.public": "Δεν υπάρχει τίποτα εδώ! Γράψε κάτι δημόσιο ή ακολούθησε χειροκίνητα χρήστες από άλλους διακομιστές για να τη γεμίσεις",
  "empty_state.no_results": "Κανένα αποτέλεσμα",
  "error.no_hashtag_feed_access": "Γίνετε μέλος ή συνδεθείτε για να δείτε και να ακολουθήσετε αυτήν την ετικέτα.",
  "error.unexpected_crash.explanation": "Είτε λόγω σφάλματος στον κώδικά μας ή λόγω ασυμβατότητας με τον περιηγητή, η σελίδα δε μπόρεσε να εμφανιστεί σωστά.",
  "error.unexpected_crash.explanation_addons": "Η σελίδα δεν μπόρεσε να εμφανιστεί σωστά. Το πρόβλημα οφείλεται πιθανόν σε κάποια επέκταση του φυλλομετρητή ή σε κάποιο αυτόματο εργαλείο μετάφρασης.",
  "error.unexpected_crash.next_steps": "Δοκίμασε να ανανεώσεις τη σελίδα. Αν αυτό δε βοηθήσει, ίσως να μπορέσεις να χρησιμοποιήσεις το Mastodon μέσω διαφορετικού περιηγητή ή κάποιας εφαρμογής.",
  "error.unexpected_crash.next_steps_addons": "Δοκίμασε να τα απενεργοποιήσεις και ανανέωσε τη σελίδα. Αν αυτό δεν βοηθήσει, ίσως να μπορέσεις να χρησιμοποιήσεις το Mastodon μέσω διαφορετικού φυλλομετρητή ή κάποιας εφαρμογής.",
  "errors.unexpected_crash.copy_stacktrace": "Αντιγραφή μηνυμάτων κώδικα στο πρόχειρο",
  "errors.unexpected_crash.report_issue": "Αναφορά προβλήματος",
  "explore.suggested_follows": "Άτομα",
  "explore.title": "Τάσεις",
  "explore.trending_links": "Νέα",
  "explore.trending_statuses": "Αναρτήσεις",
  "explore.trending_tags": "Ετικέτες",
  "featured_carousel.current": "<sr>Ανάρτηση</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Καρφιτσωμένη Ανάρτηση} other {Καρφιτσωμένες Αναρτήσεις}}",
  "featured_carousel.slide": "Ανάρτηση {current, number} από {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Τον τελευταίο καιρό έχεις δημοσιεύσει για {items}. Να προστεθούν αυτά ως αναδεδειγμένες ετικέτες;",
  "featured_tags.suggestions.add": "Προσθήκη",
  "featured_tags.suggestions.added": "Διαχειριστείτε τις αναδεδειγμένες ετικέτες σας οποιαδήποτε στιγμή κάτω από το <link>Επεξεργασία προφίλ > Αναδεδειγμένες ετικέτες</link>.",
  "featured_tags.suggestions.dismiss": "Όχι, ευχαριστώ",
  "filter_modal.added.context_mismatch_explanation": "Αυτή η κατηγορία φίλτρων δεν ισχύει για το περιεχόμενο εντός του οποίου προσπελάσατε αυτή την ανάρτηση. Αν θέλετε να φιλτραριστεί η ανάρτηση και εντός αυτού του πλαισίου, θα πρέπει να τροποποιήσετε το φίλτρο.",
  "filter_modal.added.context_mismatch_title": "Ασυμφωνία περιεχομένου!",
  "filter_modal.added.expired_explanation": "Αυτή η κατηγορία φίλτρων έχει λήξει, πρέπει να αλλάξετε την ημερομηνία λήξης για να ισχύσει.",
  "filter_modal.added.expired_title": "Ληγμένο φίλτρο!",
  "filter_modal.added.review_and_configure": "Για να ελέγξετε και να ρυθμίσετε περαιτέρω αυτή την κατηγορία φίλτρων, πηγαίνετε στο {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Ρυθμίσεις φίλτρου",
  "filter_modal.added.settings_link": "σελίδα ρυθμίσεων",
  "filter_modal.added.short_explanation": "Αυτή η ανάρτηση έχει προστεθεί στην ακόλουθη κατηγορία φίλτρου: {title}.",
  "filter_modal.added.title": "Το φίλτρο προστέθηκε!",
  "filter_modal.select_filter.context_mismatch": "δεν εφαρμόζεται σε αυτό το περιεχόμενο",
  "filter_modal.select_filter.expired": "έληξε",
  "filter_modal.select_filter.prompt_new": "Νέα κατηγορία: {name}",
  "filter_modal.select_filter.search": "Αναζήτηση ή δημιουργία",
  "filter_modal.select_filter.subtitle": "Χρησιμοποιήστε μια υπάρχουσα κατηγορία ή δημιουργήστε μια νέα",
  "filter_modal.select_filter.title": "Φιλτράρισμα αυτής της ανάρτησης",
  "filter_modal.title.status": "Φιλτράρισμα μιας ανάρτησης",
  "filter_warning.matches_filter": "Αντιστοιχεί με το φίλτρο “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "Από {count, plural, =0 {κανένα} one {ένα άτομο} other {# άτομα}} που μπορεί να ξέρεις",
  "filtered_notifications_banner.title": "Φιλτραρισμένες ειδοποιήσεις",
  "firehose.all": "Όλα",
  "firehose.local": "Αυτός ο διακομιστής",
  "firehose.remote": "Άλλοι διακομιστές",
  "follow_request.authorize": "Εξουσιοδότησε",
  "follow_request.reject": "Απέρριψε",
  "follow_requests.unlocked_explanation": "Παρόλο που ο λογαριασμός σου δεν είναι κλειδωμένος, το προσωπικό του {domain} θεώρησε πως ίσως να θέλεις να ελέγχεις χειροκίνητα αυτά τα αιτήματα ακολούθησης.",
  "follow_suggestions.curated_suggestion": "Επιλογή προσωπικού",
  "follow_suggestions.dismiss": "Να μην εμφανιστεί ξανά",
  "follow_suggestions.featured_longer": "Προσεκτικά επιλεγμένο απ' την ομάδα του {domain}",
  "follow_suggestions.friends_of_friends_longer": "Δημοφιλές μεταξύ των ατόμων που ακολουθείς",
  "follow_suggestions.hints.featured": "Αυτό το προφίλ έχει επιλεγεί προσεκτικά από την ομάδα του {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Αυτό το προφίλ είναι δημοφιλές μεταξύ των ατόμων που ακολουθείς.",
  "follow_suggestions.hints.most_followed": "Αυτό το προφίλ είναι ένα από τα πιο ακολουθούμενα στο {domain}.",
  "follow_suggestions.hints.most_interactions": "Αυτό το προφίλ έχει πάρει πρόσφατα μεγάλη προσοχή στο {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Αυτό το προφίλ είναι παρόμοιο με τα προφίλ που έχεις ακολουθήσει πρόσφατα.",
  "follow_suggestions.personalized_suggestion": "Εξατομικευμένη πρόταση",
  "follow_suggestions.popular_suggestion": "Δημοφιλής πρόταση",
  "follow_suggestions.popular_suggestion_longer": "Δημοφιλές στο {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Παρόμοιο με προφίλ που ακολούθησες πρόσφατα",
  "follow_suggestions.view_all": "Εμφάνιση όλων",
  "follow_suggestions.who_to_follow": "Ποιον να ακολουθήσεις",
  "followed_tags": "Ακολουθούμενες ετικέτες",
  "followers.hide_other_followers": "Αυτός ο χρήστης έχει επιλέξει να μην κάνει τους άλλους ακολούθους του ορατούς",
  "followers.title": "Ακολουθούν {name}",
  "following.hide_other_following": "Αυτός ο χρήστης έχει επιλέξει να μην κάνει τους υπόλοιπους που ακολουθεί ορατούς",
  "following.title": "Ακολουθούνται από {name}",
  "footer.about": "Σχετικά με",
  "footer.about_mastodon": "Σχετικά με το Mastodon",
  "footer.about_server": "Σχετικά με το {domain}",
  "footer.about_this_server": "Σχετικά με",
  "footer.directory": "Κατάλογος προφίλ",
  "footer.get_app": "Αποκτήστε την εφαρμογή",
  "footer.keyboard_shortcuts": "Συντομεύσεις πληκτρολογίου",
  "footer.privacy_policy": "Πολιτική απορρήτου",
  "footer.source_code": "Προβολή πηγαίου κώδικα",
  "footer.status": "Κατάσταση",
  "footer.terms_of_service": "Όροι υπηρεσίας",
  "form_error.blank": "Το πεδίο δεν μπορεί να είναι κενό.",
  "form_field.optional": "(προαιρετικό)",
  "generic.saved": "Αποθηκεύτηκε",
  "getting_started.heading": "Ας ξεκινήσουμε",
  "hashtag.admin_moderation": "Άνοιγμα διεπαφής συντονισμού για το #{name}",
  "hashtag.browse": "Περιήγηση αναρτήσεων με #{hashtag}",
  "hashtag.browse_from_account": "Περιήγηση αναρτήσεων από @{name} με #{hashtag}",
  "hashtag.column_header.tag_mode.all": "και {additional}",
  "hashtag.column_header.tag_mode.any": "ή {additional}",
  "hashtag.column_header.tag_mode.none": "χωρίς {additional}",
  "hashtag.column_settings.select.no_options_message": "Δεν βρέθηκαν προτάσεις",
  "hashtag.column_settings.select.placeholder": "Γράψε μερικές ετικέτες…",
  "hashtag.column_settings.tag_mode.all": "Όλα αυτά",
  "hashtag.column_settings.tag_mode.any": "Οποιοδήποτε από αυτά",
  "hashtag.column_settings.tag_mode.none": "Κανένα από αυτά",
  "hashtag.column_settings.tag_toggle": "Προσθήκη επιπλέον ταμπελών για την κολώνα",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} συμμετέχων} other {{counter} συμμετέχοντες}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} ανάρτηση} other {{counter} αναρτήσεις}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} ανάρτηση} other {{counter} αναρτήσεις}} σήμερα",
  "hashtag.feature": "Ανάδειξη στο προφίλ",
  "hashtag.follow": "Παρακολούθηση ετικέτας",
  "hashtag.mute": "Σίγαση #{hashtag}",
  "hashtag.unfeature": "Να μην αναδεικνύεται στο προφίλ",
  "hashtag.unfollow": "Διακοπή παρακολούθησης ετικέτας",
  "hashtags.and_other": "…και {count, plural, other {# ακόμα}}",
  "hints.profiles.followers_may_be_missing": "Μπορεί να λείπουν ακόλουθοι για αυτό το προφίλ.",
  "hints.profiles.follows_may_be_missing": "Άτομα που ακολουθούνται μπορεί να λείπουν απ' αυτό το προφίλ.",
  "hints.profiles.posts_may_be_missing": "Κάποιες αναρτήσεις από αυτό το προφίλ μπορεί να λείπουν.",
  "hints.profiles.see_more_followers": "Δες περισσότερους ακόλουθους στο {domain}",
  "hints.profiles.see_more_follows": "Δες περισσότερα άτομα που ακολουθούνται στο {domain}",
  "hints.profiles.see_more_posts": "Δες περισσότερες αναρτήσεις στο {domain}",
  "home.column_settings.show_quotes": "Εμφάνιση παραθέσεων",
  "home.column_settings.show_reblogs": "Εμφάνιση ενισχύσεων",
  "home.column_settings.show_replies": "Εμφάνιση απαντήσεων",
  "home.hide_announcements": "Απόκρυψη ανακοινώσεων",
  "home.pending_critical_update.body": "Παρακαλούμε ενημέρωσε τον διακομιστή Mastodon σου το συντομότερο δυνατόν!",
  "home.pending_critical_update.link": "Δείτε ενημερώσεις",
  "home.pending_critical_update.title": "Κρίσιμη ενημέρωση ασφαλείας διαθέσιμη!",
  "home.show_announcements": "Εμφάνιση ανακοινώσεων",
  "ignore_notifications_modal.disclaimer": "Το Mastodon δε μπορεί να ενημερώσει τους χρήστες ότι αγνόησες τις ειδοποιήσεις του. Η αγνόηση ειδοποιήσεων δεν θα εμποδίσει την αποστολή των ίδιων των μηνυμάτων.",
  "ignore_notifications_modal.filter_instead": "Φίλτρο αντ' αυτού",
  "ignore_notifications_modal.filter_to_act_users": "Θα μπορείς ακόμη να αποδεχθείς, να απορρίψεις ή να αναφέρεις χρήστες",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Το φιλτράρισμα βοηθά στην αποφυγή πιθανής σύγχυσης",
  "ignore_notifications_modal.filter_to_review_separately": "Μπορείς να δεις τις φιλτραρισμένες ειδοποιήσεις ξεχωριστά",
  "ignore_notifications_modal.ignore": "Αγνόηση ειδοποιήσεων",
  "ignore_notifications_modal.limited_accounts_title": "Αγνόηση ειδοποιήσεων από συντονισμένους λογαριασμούς;",
  "ignore_notifications_modal.new_accounts_title": "Αγνόηση ειδοποιήσεων από νέους λογαριασμούς;",
  "ignore_notifications_modal.not_followers_title": "Αγνόηση ειδοποιήσεων από άτομα που δε σας ακολουθούν;",
  "ignore_notifications_modal.not_following_title": "Αγνόηση ειδοποιήσεων από άτομα που δεν ακολουθείς;",
  "ignore_notifications_modal.private_mentions_title": "Αγνόηση ειδοποιήσεων από μη ζητηθείσες ιδιωτικές επισημάνσεις;",
  "info_button.label": "Βοήθεια",
  "info_button.what_is_alt_text": "<h1>Τι είναι το εναλλακτικό κείμενο;</h1> <p>Το εναλλακτικό κείμενο (alt text) παρέχει περιγραφές εικόνας για άτομα με προβλήματα όρασης, διαδικτυακές συνδέσεις χαμηλής ταχύτητας ή για άτομα που αναζητούν επιπλέον περιεχόμενο.</p> <p>Μπορείς να βελτιώσεις την προσβασιμότητα και την κατανόηση για όλους, γράφοντας σαφές, συνοπτικό και αντικειμενικό εναλλακτικό κείμενο.</p> <ul> <li>Κατέγραψε σημαντικά στοιχεία</li> <li>Συνόψισε το κείμενο στις εικόνες</li> <li>Χρησιμοποίησε δομή κανονικής πρότασης</li> <li>Απέφυγε περιττές πληροφορίες</li> <li>Εστίασε στις τάσεις και τα βασικά ευρήματα σε σύνθετα οπτικά στοιχεία (όπως διαγράμματα ή χάρτες)</li> </ul>",
  "interaction_modal.action": "Για να αλληλεπιδράσετε με την ανάρτηση του/της {name}, πρέπει να συνδεθείτε στον λογαριασμό σας σε οποιονδήποτε διακομιστή Mastodon χρησιμοποιείτε.",
  "interaction_modal.action_follow": "Για να ακολουθήσετε τον/την {name}, πρέπει να συνδεθείτε στον λογαριασμό σας σε οποιονδήποτε διακομιστή Mastodon χρησιμοποιείτε.",
  "interaction_modal.go": "Πάμε",
  "interaction_modal.no_account_yet": "Δεν έχεις ακόμη λογαριασμό;",
  "interaction_modal.on_another_server": "Σε διαφορετικό διακομιστή",
  "interaction_modal.on_this_server": "Σε αυτόν τον διακομιστή",
  "interaction_modal.title": "Συνδεθείτε για να συνεχίσετε",
  "interaction_modal.username_prompt": "Πχ. {example}",
  "intervals.full.days": "{number, plural, one {# μέρα} other {# μέρες}}",
  "intervals.full.hours": "{number, plural, one {# ώρα} other {# ώρες}}",
  "intervals.full.minutes": "{number, plural, one {# λεπτό} other {# λεπτά}}",
  "keyboard_shortcuts.back": "Μετάβαση πίσω",
  "keyboard_shortcuts.blocked": "Άνοιγμα λίστας αποκλεισμένων χρηστών",
  "keyboard_shortcuts.boost": "Ενίσχυση ανάρτησης",
  "keyboard_shortcuts.column": "Εστίαση στη στήλη",
  "keyboard_shortcuts.compose": "Εστίαση στην περιοχή συγγραφής κειμένου",
  "keyboard_shortcuts.description": "Περιγραφή",
  "keyboard_shortcuts.direct": "Άνοιγμα της στήλης ιδιωτικών επισημάνσεων",
  "keyboard_shortcuts.down": "Μετακίνηση προς τα κάτω στη λίστα",
  "keyboard_shortcuts.enter": "Άνοιγμα ανάρτησης",
  "keyboard_shortcuts.explore": "Άνοιγμα χρονολογίου τάσεων",
  "keyboard_shortcuts.favourite": "Αγάπησε την ανάρτηση",
  "keyboard_shortcuts.favourites": "Άνοιγμα λίστας αγαπημένων",
  "keyboard_shortcuts.federated": "Άνοιγμα ομοσπονδιακής ροής",
  "keyboard_shortcuts.heading": "Συντομεύσεις πληκτρολογίου",
  "keyboard_shortcuts.home": "Άνοιγμα ροής αρχικής σελίδας",
  "keyboard_shortcuts.hotkey": "Συντόμευση",
  "keyboard_shortcuts.legend": "Εμφάνιση αυτού του οδηγού",
  "keyboard_shortcuts.load_more": "Εστίαση στο κουμπί \"Φόρτωση περισσότερων\"",
  "keyboard_shortcuts.local": "Άνοιγμα τοπικής ροής",
  "keyboard_shortcuts.mention": "Επισήμανση συντάκτη",
  "keyboard_shortcuts.muted": "Άνοιγμα λίστας αποσιωπημένων χρηστών",
  "keyboard_shortcuts.my_profile": "Άνοιγμα του προφίλ σου",
  "keyboard_shortcuts.notifications": "Άνοιγμα στήλης ειδοποιήσεων",
  "keyboard_shortcuts.open_media": "Άνοιγμα πολυμέσων",
  "keyboard_shortcuts.pinned": "Άνοιγμα λίστας καρφιτσωμένων αναρτήσεων",
  "keyboard_shortcuts.profile": "Άνοιγμα προφίλ συντάκτη",
  "keyboard_shortcuts.quote": "Παράθεση ανάρτησης",
  "keyboard_shortcuts.reply": "Απάντηση στην ανάρτηση",
  "keyboard_shortcuts.requests": "Άνοιγμα λίστας αιτημάτων ακολούθησης",
  "keyboard_shortcuts.search": "Εστίαση στη γραμμή αναζήτησης",
  "keyboard_shortcuts.spoilers": "Εμφάνιση/απόκρυψη πεδίου CW",
  "keyboard_shortcuts.start": "Άνοιγμα της στήλης \"Ας ξεκινήσουμε\"",
  "keyboard_shortcuts.toggle_hidden": "Εμφάνιση/απόκρυψη κειμένου πίσω από το CW",
  "keyboard_shortcuts.toggle_sensitivity": "Εμφάνιση/απόκρυψη πολυμέσων",
  "keyboard_shortcuts.toot": "Δημιουργία νέας ανάρτησης",
  "keyboard_shortcuts.top": "Μετακίνηση στην κορυφή της λίστας",
  "keyboard_shortcuts.translate": "για να μεταφραστεί μια ανάρτηση",
  "keyboard_shortcuts.unfocus": "Αποεστίαση του πεδίου σύνθεσης/αναζήτησης",
  "keyboard_shortcuts.up": "Μετακίνηση προς τα πάνω στη λίστα",
  "learn_more_link.got_it": "Το κατάλαβα",
  "learn_more_link.learn_more": "Μάθε περισσότερα",
  "lightbox.close": "Κλείσιμο",
  "lightbox.next": "Επόμενο",
  "lightbox.previous": "Προηγούμενο",
  "lightbox.zoom_in": "Εστίαση στο πραγματικό μέγεθος",
  "lightbox.zoom_out": "Εστίαση για προσαρμογή",
  "limited_account_hint.action": "Εμφάνιση προφίλ ούτως ή άλλως",
  "limited_account_hint.title": "Αυτό το προφίλ έχει αποκρυφτεί από τους διαχειριστές του διακομιστή {domain}.",
  "link_preview.author": "Από {name}",
  "link_preview.more_from_author": "Περισσότερα από {name}",
  "link_preview.shares": "{count, plural, one {{counter} ανάρτηση} other {{counter} αναρτήσεις}}",
  "lists.add_member": "Προσθήκη",
  "lists.add_to_list": "Προσθήκη στη λίστα",
  "lists.add_to_lists": "Προσθήκη {name} σε λίστες",
  "lists.create": "Δημιουργία",
  "lists.create_a_list_to_organize": "Δημιούργησε μια νέα λίστα για να οργανώσεις την Αρχική σου ροή",
  "lists.create_list": "Δημιουργία λίστας",
  "lists.delete": "Διαγραφή λίστας",
  "lists.done": "Έγινε",
  "lists.edit": "Επεξεργασία λίστας",
  "lists.exclusive": "Απόκρυψη μελών από την Αρχική",
  "lists.exclusive_hint": "Αν κάποιος είναι σε αυτή τη λίστα, απόκρυψέ τον από την Αρχική ροή σου για να αποφύγεις να βλέπεις τις αναρτήσεις του δύο φορές.",
  "lists.find_users_to_add": "Εύρεση χρηστών για προσθήκη",
  "lists.list_members_count": "{count, plural, one {# μέλος} other {# μέλη}}",
  "lists.list_name": "Όνομα λίστας",
  "lists.new_list_name": "Νέο όνομα λίστας",
  "lists.no_lists_yet": "Καμία λίστα ακόμη.",
  "lists.no_members_yet": "Κανένα μέλος ακόμη.",
  "lists.no_results_found": "Δεν βρέθηκαν αποτελέσματα.",
  "lists.remove_member": "Αφαίρεση",
  "lists.replies_policy.followed": "Οποιονδήποτε χρήστης που ακολουθείς",
  "lists.replies_policy.list": "Μέλη της λίστας",
  "lists.replies_policy.none": "Κανέναν",
  "lists.save": "Αποθήκευση",
  "lists.search": "Αναζήτηση",
  "lists.show_replies_to": "Συμπερίληψη απαντήσεων από τα μέλη της λίστας προς",
  "load_pending": "{count, plural, one {# νέο στοιχείο} other {# νέα στοιχεία}}",
  "loading_indicator.label": "Φόρτωση…",
  "media_gallery.hide": "Απόκρυψη",
  "moved_to_account_banner.text": "Ο λογαριασμός σου {disabledAccount} είναι προσωρινά απενεργοποιημένος επειδή μεταφέρθηκες στον {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Απόκρυψη από ειδοποιήσεις",
  "mute_modal.hide_options": "Απόκρυψη επιλογών",
  "mute_modal.indefinite": "Μέχρι να κάνω άρση σίγασης",
  "mute_modal.show_options": "Εμφάνιση επιλογών",
  "mute_modal.they_can_mention_and_follow": "Μπορεί να σε επισημάνει και να σε ακολουθήσει, αλλά δε θα τον βλέπεις.",
  "mute_modal.they_wont_know": "Δε θα ξέρει ότι είναι σε σίγαση.",
  "mute_modal.title": "Σίγαση χρήστη;",
  "mute_modal.you_wont_see_mentions": "Δε θα βλέπεις τις αναρτήσεις που τον επισημαίνουν.",
  "mute_modal.you_wont_see_posts": "Μπορεί ακόμη να βλέπει τις αναρτήσεις σου, αλλά δε θα βλέπεις τις δικές του.",
  "navigation_bar.about": "Σχετικά με",
  "navigation_bar.account_settings": "Κωδικός πρόσβασης και ασφάλεια",
  "navigation_bar.administration": "Διαχείριση",
  "navigation_bar.advanced_interface": "Άνοιγμα σε προηγμένη διεπαφή ιστού",
  "navigation_bar.automated_deletion": "Αυτοματοποιημένη διαγραφή αναρτήσεων",
  "navigation_bar.blocks": "Αποκλεισμένοι χρήστες",
  "navigation_bar.bookmarks": "Σελιδοδείκτες",
  "navigation_bar.collections": "Συλλογές",
  "navigation_bar.direct": "Ιδιωτικές επισημάνσεις",
  "navigation_bar.domain_blocks": "Αποκλεισμένοι τομείς",
  "navigation_bar.favourites": "Αγαπημένα",
  "navigation_bar.filters": "Αποσιωπημένες λέξεις",
  "navigation_bar.follow_requests": "Αιτήματα ακολούθησης",
  "navigation_bar.followed_tags": "Ακολουθούμενες ετικέτες",
  "navigation_bar.follows_and_followers": "Ακολουθείς και σε ακολουθούν",
  "navigation_bar.import_export": "Εισαγωγή και εξαγωγή",
  "navigation_bar.lists": "Λίστες",
  "navigation_bar.live_feed_local": "Ζωντανή ροή (τοπική)",
  "navigation_bar.live_feed_public": "Ζωντανή ροή (δημόσια)",
  "navigation_bar.logout": "Αποσύνδεση",
  "navigation_bar.moderation": "Συντονισμός",
  "navigation_bar.more": "Περισσότερα",
  "navigation_bar.mutes": "Αποσιωπημένοι χρήστες",
  "navigation_bar.opened_in_classic_interface": "Αναρτήσεις, λογαριασμοί και άλλες συγκεκριμένες σελίδες ανοίγονται από προεπιλογή στην κλασική διεπαφή ιστού.",
  "navigation_bar.preferences": "Προτιμήσεις",
  "navigation_bar.privacy_and_reach": "Ιδιωτικότητα και προσιτότητα",
  "navigation_bar.search": "Αναζήτηση",
  "navigation_bar.search_trends": "Αναζήτηση / Τάσεις",
  "navigation_panel.collapse_followed_tags": "Σύμπτυξη μενού ετικετών που ακολουθείτε",
  "navigation_panel.collapse_lists": "Σύμπτυξη μενού λίστας",
  "navigation_panel.expand_followed_tags": "Επέκταση μενού ετικετών που ακολουθείτε",
  "navigation_panel.expand_lists": "Επέκταση μενού λίστας",
  "not_signed_in_indicator.not_signed_in": "Πρέπει να συνδεθείς για να αποκτήσεις πρόσβαση σε αυτόν τον πόρο.",
  "notification.added_to_collection": "{name} σε πρόσθεσε σ' αυτήν τη συλλογή",
  "notification.admin.report": "Ο/Η {name} ανέφερε τον/την {target}",
  "notification.admin.report_account": "Ο χρήστης {name} ανέφερε {count, plural, one {μία ανάρτηση} other {# αναρτήσεις}} από {target} για {category}",
  "notification.admin.report_account_other": "Ο χρήστης {name} ανέφερε {count, plural, one {μία ανάρτηση} other {# αναρτήσεις}} από {target}",
  "notification.admin.report_statuses": "Ο χρήστης {name} ανέφερε τον χρήστη {target} για {category}",
  "notification.admin.report_statuses_other": "Ο χρήστης {name} ανέφερε τον χρήστη {target}",
  "notification.admin.sign_up": "{name} έχει εγγραφεί",
  "notification.admin.sign_up.name_and_others": "{name} και {count, plural, one {# ακόμα} other {# ακόμα}} έχουν εγγραφεί",
  "notification.annual_report.message": "Το #Wrapstodon {year} σε περιμένει! Αποκάλυψε τα στιγμιότυπα της χρονιάς και αξέχαστες στιγμές σου στο Mastodon!",
  "notification.annual_report.view": "Προβολή #Wrapstodon",
  "notification.collection_update": "{name} επεξεργάστηκε μια συλλογή στην οποία περιλαμβάνεσαι",
  "notification.favourite": "{name} αγάπησε την ανάρτηση σου",
  "notification.favourite.name_and_others_with_link": "{name} και <a>{count, plural, one {# ακόμα} other {# ακόμα}}</a> αγάπησαν την ανάρτησή σου",
  "notification.favourite_pm": "Ο χρήστης {name} αγάπησε την ιδιωτική σου επισήμανση",
  "notification.favourite_pm.name_and_others_with_link": "Ο χρήστης {name} και <a>{count, plural, one {# ακόμα} other {# ακόμα}}</a> αγάπησαν την ιδωτική σου επισήμανση",
  "notification.follow": "Ο χρήστης {name} σε ακολούθησε",
  "notification.follow.name_and_others": "Ο χρήστης {name} και <a>{count, plural, one {# ακόμα} other {# ακόμα}}</a> σε ακολούθησαν",
  "notification.follow_request": "Ο/H {name} ζήτησε να σε ακολουθήσει",
  "notification.follow_request.name_and_others": "{name} και {count, plural, one {# άλλος} other {# άλλοι}} ζήτησαν να σε ακολουθήσουν",
  "notification.label.mention": "Επισήμανση",
  "notification.label.private_mention": "Ιδιωτική επισήμανση",
  "notification.label.private_reply": "Ιδιωτική απάντηση",
  "notification.label.quote": "Ο/Η {name} έκανε παράθεση της ανάρτησής σου",
  "notification.label.reply": "Απάντηση",
  "notification.mention": "Επισήμανση",
  "notification.mentioned_you": "Ο χρήστης {name} σε επισήμανε",
  "notification.moderation-warning.learn_more": "Μάθε περισσότερα",
  "notification.moderation_warning": "Έχετε λάβει μία προειδοποίηση συντονισμού",
  "notification.moderation_warning.action_delete_statuses": "Ορισμένες από τις αναρτήσεις σου έχουν αφαιρεθεί.",
  "notification.moderation_warning.action_disable": "Ο λογαριασμός σου έχει απενεργοποιηθεί.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Μερικές από τις αναρτήσεις σου έχουν σημανθεί ως ευαίσθητες.",
  "notification.moderation_warning.action_none": "Ο λογαριασμός σου έχει λάβει προειδοποίηση συντονισμού.",
  "notification.moderation_warning.action_sensitive": "Οι αναρτήσεις σου θα σημαίνονται ως ευαίσθητες από 'δω και στο εξής.",
  "notification.moderation_warning.action_silence": "Ο λογαριασμός σου έχει περιοριστεί.",
  "notification.moderation_warning.action_suspend": "Ο λογαριασμός σου έχει ανασταλεί.",
  "notification.own_poll": "Η δημοσκόπησή σου έληξε",
  "notification.poll": "Μία ψηφοφορία στην οποία συμμετείχες έχει τελειώσει",
  "notification.quoted_update": "{name} επεξεργάστηκε μία ανάρτηση που παρέθεσες",
  "notification.reblog": "Ο/Η {name} ενίσχυσε την ανάρτηση σου",
  "notification.reblog.name_and_others_with_link": "{name} και <a>{count, plural, one {# ακόμα} other {# ακόμα}}</a> ενίσχυσαν την ανάρτησή σου",
  "notification.relationships_severance_event": "Χάθηκαν συνδέσεις με το {name}",
  "notification.relationships_severance_event.account_suspension": "Ένας διαχειριστής από το {from} ανέστειλε το {target}, το οποίο σημαίνει ότι δεν μπορείς πλέον να λαμβάνεις ενημερώσεις από αυτούς ή να αλληλεπιδράς μαζί τους.",
  "notification.relationships_severance_event.domain_block": "Ένας διαχειριστής από {from} έχει μπλοκάρει το {target}, συμπεριλαμβανομένων {followersCount} από τους ακόλουθούς σου και {followingCount, plural, one {# λογαριασμό} other {# λογαριασμούς}} που ακολουθείς.",
  "notification.relationships_severance_event.learn_more": "Μάθε περισσότερα",
  "notification.relationships_severance_event.user_domain_block": "Έχεις αποκλείσει τον λογαριασμό {target}, αφαιρώντας {followersCount} από τους ακόλουθούς σου και {followingCount, plural, one {# λογαριασμό} other {# λογαριασμούς}} που ακολουθείς.",
  "notification.status": "Ο/Η {name} μόλις ανέρτησε κάτι",
  "notification.update": "{name} επεξεργάστηκε μια ανάρτηση",
  "notification_requests.accept": "Αποδοχή",
  "notification_requests.accept_multiple": "{count, plural, one {Αποδοχή # αιτήματος…} other {Αποδοχή # αιτημάτων…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Αποδοχή αιτήματος} other {Αποδοχή αιτημάτων}}",
  "notification_requests.confirm_accept_multiple.message": "Πρόκειται να αποδεχτείς {count, plural, one {ένα αίτημα ειδοποίησης} other {# αιτήματα ειδοποίησης}}. Σίγουρα θες να συνεχίσεις;",
  "notification_requests.confirm_accept_multiple.title": "Αποδοχή αιτήσεων ειδοποίησης;",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Παράβλεψη αιτήματος} other {Παράβλεψη αιτημάτων}}",
  "notification_requests.confirm_dismiss_multiple.message": "Πρόκειται να παραβλέψεις {count, plural, one {ένα αίτημα ειδοποίησης} other {# αιτήματα ειδοποίησης}}. Δεν θα μπορείς να έχεις πρόσβαση εύκολα {count, plural, one {σε αυτό} other {σε αυτά}} ξανά. Σίγουρα θες να συνεχίσεις;",
  "notification_requests.confirm_dismiss_multiple.title": "Παράβλεψη αιτημάτων ειδοποίησης;",
  "notification_requests.dismiss": "Παράβλεψη",
  "notification_requests.dismiss_multiple": "{count, plural, one {Παράβλεψη # αιτήματος…} other {Παράβλεψη # αιτημάτων…}}",
  "notification_requests.edit_selection": "Επεξεργασία",
  "notification_requests.exit_selection": "Έγινε",
  "notification_requests.explainer_for_limited_account": "Οι ειδοποιήσεις από αυτόν τον λογαριασμό έχουν φιλτραριστεί επειδή ο λογαριασμός έχει περιοριστεί από έναν συντονιστή.",
  "notification_requests.explainer_for_limited_remote_account": "Οι ειδοποιήσεις από αυτόν τον λογαριασμό έχουν φιλτραριστεί επειδή ο λογαριασμός ή ο διακομιστής του έχει περιοριστεί από έναν συντονιστή.",
  "notification_requests.maximize": "Μεγιστοποίηση",
  "notification_requests.minimize_banner": "Ελαχιστοποίηση μπάνερ φιλτραρισμένων ειδοποιήσεων",
  "notification_requests.notifications_from": "Ειδοποιήσεις από {name}",
  "notification_requests.title": "Φιλτραρισμένες ειδοποιήσεις",
  "notification_requests.view": "Προβολή ειδοποιήσεων",
  "notifications.clear": "Καθαρισμός ειδοποιήσεων",
  "notifications.clear_confirmation": "Σίγουρα θέλεις να καθαρίσεις μόνιμα όλες τις ειδοποιήσεις σου;",
  "notifications.clear_title": "Εκκαθάριση ειδοποιήσεων;",
  "notifications.column_settings.admin.report": "Νέες αναφορές:",
  "notifications.column_settings.admin.sign_up": "Νέες εγγραφές:",
  "notifications.column_settings.alert": "Ειδοποιήσεις επιφάνειας εργασίας",
  "notifications.column_settings.favourite": "Αγαπημένα:",
  "notifications.column_settings.filter_bar.advanced": "Εμφάνιση όλων των κατηγοριών",
  "notifications.column_settings.filter_bar.category": "Μπάρα γρήγορου φίλτρου",
  "notifications.column_settings.follow": "Νέοι ακόλουθοι:",
  "notifications.column_settings.follow_request": "Νέο αίτημα ακολούθησης:",
  "notifications.column_settings.group": "Ομάδα",
  "notifications.column_settings.mention": "Επισημάνσεις:",
  "notifications.column_settings.poll": "Αποτελέσματα δημοσκόπησης:",
  "notifications.column_settings.push": "Ειδοποιήσεις Push",
  "notifications.column_settings.quote": "Παραθέσεις:",
  "notifications.column_settings.reblog": "Ενισχύσεις:",
  "notifications.column_settings.show": "Εμφάνισε σε στήλη",
  "notifications.column_settings.sound": "Αναπαραγωγή ήχου",
  "notifications.column_settings.status": "Νέες αναρτήσεις:",
  "notifications.column_settings.unread_notifications.category": "Μη αναγνωσμένες ειδοποιήσεις",
  "notifications.column_settings.unread_notifications.highlight": "Επισήμανση μη αναγνωσμένων ειδοποιήσεων",
  "notifications.column_settings.update": "Επεξεργασίες:",
  "notifications.filter.all": "Όλες",
  "notifications.filter.boosts": "Προωθήσεις",
  "notifications.filter.favourites": "Αγαπημένα",
  "notifications.filter.follows": "Ακολουθείς",
  "notifications.filter.mentions": "Επισημάνσεις",
  "notifications.filter.polls": "Αποτελέσματα δημοσκόπησης",
  "notifications.filter.statuses": "Ενημερώσεις από όσους ακολουθείς",
  "notifications.grant_permission": "Χορήγηση άδειας.",
  "notifications.group": "{count} ειδοποιήσεις",
  "notifications.mark_as_read": "Σήμανε όλες τις ειδοποιήσεις ως αναγνωσμένες",
  "notifications.permission_denied": "Οι ειδοποιήσεις στην επιφάνεια εργασίας δεν είναι διαθέσιμες διότι έχει απορριφθεί κάποιο προηγούμενο αίτημα άδειας",
  "notifications.permission_denied_alert": "Δεν είναι δυνατή η ενεργοποίηση των ειδοποιήσεων της επιφάνειας εργασίας, καθώς η άδεια του προγράμματος περιήγησης έχει απορριφθεί νωρίτερα",
  "notifications.permission_required": "Οι ειδοποιήσεις δεν είναι διαθέσιμες επειδή δεν έχει δοθεί η απαιτούμενη άδεια.",
  "notifications.policy.accept": "Αποδοχή",
  "notifications.policy.accept_hint": "Εμφάνιση στις ειδοποιήσεις",
  "notifications.policy.drop": "Αγνόηση",
  "notifications.policy.drop_hint": "Στείλε τες στο υπερπέραν, για να μην τις ξαναδείτε",
  "notifications.policy.filter": "Φίλτρο",
  "notifications.policy.filter_hint": "Αποστολή στα εισερχόμενα φιλτραρισμένων ειδοποιήσεων",
  "notifications.policy.filter_limited_accounts_hint": "Περιορισμένη από συντονιστές διακομιστή",
  "notifications.policy.filter_limited_accounts_title": "Συντονισμένοι λογαριασμοί",
  "notifications.policy.filter_new_accounts.hint": "Δημιουργήθηκε εντός {days, plural, one {της τελευταίας ημέρας} other {των τελευταίων # ημερών}}",
  "notifications.policy.filter_new_accounts_title": "Νέοι λογαριασμοί",
  "notifications.policy.filter_not_followers_hint": "Συμπεριλαμβανομένων των ατόμων που σας έχουν ακολουθήσει λιγότερο από {days, plural, one {μια ημέρα} other {# ημέρες}} πριν",
  "notifications.policy.filter_not_followers_title": "Άτομα που δε σε ακολουθούν",
  "notifications.policy.filter_not_following_hint": "Μέχρι να τους εγκρίνεις χειροκίνητα",
  "notifications.policy.filter_not_following_title": "Άτομα που δεν ακολουθείς",
  "notifications.policy.filter_private_mentions_hint": "Φιλτράρισμα εκτός αν είναι απάντηση σε δική σου επισήμανση ή αν ακολουθείς τον αποστολέα",
  "notifications.policy.filter_private_mentions_title": "Μη συναινετικές ιδιωτικές επισημάνσεις",
  "notifications.policy.title": "Διαχείριση ειδοποιήσεων από…",
  "notifications_permission_banner.enable": "Ενεργοποίηση ειδοποιήσεων επιφάνειας εργασίας",
  "notifications_permission_banner.how_to_control": "Για να λαμβάνεις ειδοποιήσεις όταν το Mastodon δεν είναι ανοιχτό, ενεργοποίησε τις ειδοποιήσεις επιφάνειας εργασίας. Μπορείς να ελέγξεις με ακρίβεια ποιοι τύποι αλληλεπιδράσεων δημιουργούν ειδοποιήσεις επιφάνειας εργασίας μέσω του κουμπιού {icon} μόλις ενεργοποιηθούν.",
  "notifications_permission_banner.title": "Μη χάσεις στιγμή",
  "onboarding.follows.back": "Πίσω",
  "onboarding.follows.empty": "Δυστυχώς, δεν μπορούν να εμφανιστούν αποτελέσματα αυτή τη στιγμή. Μπορείς να προσπαθήσεις να χρησιμοποιήσεις την αναζήτηση ή να περιηγηθείς στη σελίδα εξερεύνησης για να βρεις άτομα να ακολουθήσεις ή να δοκιμάσεις ξανά αργότερα.",
  "onboarding.follows.next": "Επόμενο: Ρυθμίστε το προφίλ σας",
  "onboarding.follows.search": "Αναζήτηση",
  "onboarding.follows.title": "Ακολούθησε άτομα για να ξεκινήσεις",
  "onboarding.profile.discoverable": "Κάνε το προφίλ μου ανακαλύψιμο",
  "onboarding.profile.discoverable_hint": "Όταν επιλέγεις την δυνατότητα ανακάλυψης στο Mastodon, οι αναρτήσεις σου μπορεί να εμφανιστούν στα αποτελέσματα αναζήτησης και τις τάσεις, και το προφίλ σου μπορεί να προτείνεται σε άτομα με παρόμοια ενδιαφέροντα με εσένα.",
  "onboarding.profile.display_name": "Εμφανιζόμενο όνομα",
  "onboarding.profile.display_name_hint": "Το πλήρες ή το διασκεδαστικό σου όνομα…",
  "onboarding.profile.finish": "Ολοκλήρωση",
  "onboarding.profile.note": "Βιογραφικό",
  "onboarding.profile.note_hint": "Μπορείς να @επισημάνεις άλλα άτομα ή #ετικέτες…",
  "onboarding.profile.title": "Ρύθμιση προφίλ",
  "onboarding.profile.upload_avatar": "Μεταφόρτωση εικόνας προφίλ",
  "onboarding.profile.upload_header": "Μεταφόρτωση κεφαλίδας προφίλ",
  "password_confirmation.exceeds_maxlength": "Η επιβεβαίωση κωδικού πρόσβασης υπερβαίνει το μέγιστο μήκος κωδικού πρόσβασης",
  "password_confirmation.mismatching": "Η επιβεβαίωση του κωδικού πρόσβασης δε συμπίπτει",
  "picture_in_picture.restore": "Βάλε το πίσω",
  "poll.closed": "Κλειστή",
  "poll.refresh": "Ανανέωση",
  "poll.reveal": "Δείτε τα αποτελέσματα",
  "poll.total_people": "{count, plural, one {# άτομο} other {# άτομα}}",
  "poll.total_votes": "{count, plural, one {# ψήφος} other {# ψήφοι}}",
  "poll.vote": "Ψήφισε",
  "poll.voted": "Ψήφισες αυτήν την απάντηση",
  "poll.votes": "{votes, plural, one {# ψήφος} other {# ψήφοι}}",
  "poll_button.add_poll": "Προσθήκη δημοσκόπησης",
  "poll_button.remove_poll": "Αφαίρεση δημοσκόπησης",
  "privacy.change": "Προσαρμογή ιδιωτικότητας ανάρτησης",
  "privacy.direct.long": "Όλοι όσοι επισημάνθηκαν στην ανάρτηση",
  "privacy.direct.short": "Ιδιωτική επισήμανση",
  "privacy.private.long": "Μόνο οι ακόλουθοί σας",
  "privacy.private.short": "Ακόλουθοι",
  "privacy.public.long": "Όλοι εντός και εκτός του Mastodon",
  "privacy.public.short": "Δημόσια",
  "privacy.quote.anyone": "{visibility}, παραθέσεις επιτρεπτές",
  "privacy.quote.disabled": "{visibility}, παραθέσεις απενεργοποιημένες",
  "privacy.quote.limited": "{visibility}, παραθέσεις περιορισμένες",
  "privacy.unlisted.additional": "Αυτό συμπεριφέρεται ακριβώς όπως το δημόσιο, εκτός από το ότι η ανάρτηση δεν θα εμφανιστεί σε ζωντανές ροές ή ετικέτες, εξερεύνηση ή αναζήτηση στο Mastodon, ακόμη και αν το έχεις επιλέξει για τον λογαριασμό σου.",
  "privacy.unlisted.long": "Κρυμμένη από τα αποτελέσματα αναζήτησης Mastodon, τις τάσεις και τις δημόσιες ροές",
  "privacy.unlisted.short": "Ήσυχα δημόσια",
  "privacy_policy.last_updated": "Τελευταία ενημέρωση {date}",
  "privacy_policy.title": "Πολιτική Απορρήτου",
  "quote_error.edit": "Δεν μπορούν να προστεθούν παραθέσεις κατά την επεξεργασία μιας ανάρτησης.",
  "quote_error.poll": "Η παράθεση δεν επιτρέπεται με δημοσκοπήσεις.",
  "quote_error.private_mentions": "Η παράθεση δεν επιτρέπεται με άμεσες επισημάνσεις.",
  "quote_error.quote": "Επιτρέπεται μόνο μία παράθεση τη φορά.",
  "quote_error.unauthorized": "Δεν είστε εξουσιοδοτημένοι να παραθέσετε αυτή την ανάρτηση.",
  "quote_error.upload": "Η παράθεση δεν επιτρέπεται με συνημμένα πολυμέσων.",
  "recommended": "Προτείνεται",
  "refresh": "Ανανέωση",
  "regeneration_indicator.please_stand_by": "Παρακαλούμε περίμενε.",
  "regeneration_indicator.preparing_your_home_feed": "Ετοιμάζουμε την αρχική σου ροή…",
  "relative_time.days": "{number}η",
  "relative_time.full.days": "πριν από {number, plural, one {# μέρα} other {# μέρες}}",
  "relative_time.full.hours": "πριν από {number, plural, one {# ώρα} other {# ώρες}}",
  "relative_time.full.just_now": "μόλις τώρα",
  "relative_time.full.minutes": "πριν από {number, plural, one {# λεπτό} other {# λεπτά}}",
  "relative_time.full.seconds": "πριν από {number, plural, one {# δευτερόλεπτο} other {# δευτερόλεπτα}}",
  "relative_time.hours": "{number}ω",
  "relative_time.just_now": "τώρα",
  "relative_time.minutes": "{number}λ",
  "relative_time.seconds": "{number}δ",
  "relative_time.today": "σήμερα",
  "remove_quote_hint.button_label": "Το 'πιασα",
  "remove_quote_hint.message": "Μπορείτε να το κάνεις από το μενού επιλογών {icon}.",
  "remove_quote_hint.title": "Θες να αφαιρέσεις την ανάρτηση που παρέθεσες;",
  "reply_indicator.attachments": "{count, plural, one {# συνημμένο} other {# συνημμένα}}",
  "reply_indicator.cancel": "Άκυρο",
  "reply_indicator.poll": "Δημοσκόπηση",
  "report.block": "Αποκλεισμός",
  "report.block_explanation": "Δεν θα βλέπεις τις αναρτήσεις του. Δεν θα μπορεί να δει τις αναρτήσεις σου ή να σε ακολουθήσει. Θα μπορεί να δει ότι έχει αποκλειστεί.",
  "report.categories.legal": "Νομικό περιεχόμενο",
  "report.categories.other": "Άλλες",
  "report.categories.spam": "Ανεπιθύμητα",
  "report.categories.violation": "Το περιεχόμενο παραβιάζει έναν ή περισσότερους κανόνες διακομιστή",
  "report.category.subtitle": "Επέλεξε την καλύτερη αντιστοίχιση",
  "report.category.title": "Πείτε μας τι συμβαίνει με {type}",
  "report.category.title_account": "προφίλ",
  "report.category.title_status": "ανάρτηση",
  "report.close": "Τέλος",
  "report.collection_comment": "Γιατί θέλετε να αναφέρετε αυτήν τη συλλογή;",
  "report.comment.title": "Υπάρχει κάτι άλλο που νομίζεις ότι θα πρέπει να γνωρίζουμε;",
  "report.forward": "Προώθηση προς {target}",
  "report.forward_hint": "Ο λογαριασμός είναι από διαφορετικό διακομιστή. Να σταλεί ανώνυμο αντίγραφο της αναφοράς και εκεί;",
  "report.mute": "Σίγαση",
  "report.mute_explanation": "Δεν θα βλέπεις τις αναρτήσεις τους. Εκείνοι μπορούν ακόμη να σε ακολουθούν και να βλέπουν τις αναρτήσεις σου χωρίς να γνωρίζουν ότι είναι σε σίγαση.",
  "report.next": "Επόμενο",
  "report.placeholder": "Επιπρόσθετα σχόλια",
  "report.reasons.dislike": "Δεν μου αρέσει",
  "report.reasons.dislike_description": "Δεν είναι κάτι που θα ήθελες να δεις",
  "report.reasons.legal": "Είναι παράνομο",
  "report.reasons.legal_description": "Πιστεύετε ότι παραβιάζει το νόμο της χώρας σας ή της χώρας του διακομιστή",
  "report.reasons.other": "Είναι κάτι άλλο",
  "report.reasons.other_description": "Το ζήτημα δεν ταιριάζει σε άλλες κατηγορίες",
  "report.reasons.spam": "Είναι σπαμ",
  "report.reasons.spam_description": "Κακόβουλοι σύνδεσμοι, πλαστή αλληλεπίδραση ή επαναλαμβανόμενες απαντήσεις",
  "report.reasons.violation": "Παραβαίνει τους κανόνες του διακομιστή",
  "report.reasons.violation_description": "Γνωρίζεις ότι παραβιάζει συγκεκριμένους κανόνες",
  "report.rules.subtitle": "Επίλεξε όλα όσα ισχύουν",
  "report.rules.title": "Ποιοι κανόνες παραβιάζονται;",
  "report.statuses.subtitle": "Επίλεξε όλα όσα ισχύουν",
  "report.statuses.title": "Υπάρχουν αναρτήσεις που τεκμηριώνουν αυτή την αναφορά;",
  "report.submission_error": "Δεν ήταν δυνατή η υποβολή της αναφοράς",
  "report.submission_error_details": "Παρακαλούμε ελέγξτε τη σύνδεση δικτύου σας και προσπαθήστε ξανά αργότερα.",
  "report.submit": "Υποβολή",
  "report.target": "Αναφορά {target}",
  "report.thanks.take_action": "Αυτές είναι οι επιλογές σας για να ελέγχετε τι βλέπετε στο Mastodon:",
  "report.thanks.take_action_actionable": "Ενώ το εξετάζουμε, μπορείς να δράσεις εναντίον του @{name}:",
  "report.thanks.title": "Δε θες να το βλέπεις;",
  "report.thanks.title_actionable": "Σε ευχαριστούμε για την αναφορά, θα το διερευνήσουμε.",
  "report.unfollow": "Άρση ακολούθησης του @{name}",
  "report.unfollow_explanation": "Ακολουθείς αυτό τον λογαριασμό. Για να μη βλέπεις τις αναρτήσεις τους στη δική σου ροή, πάψε να τον ακολουθείς.",
  "report_notification.attached_statuses": "{count, plural, one {{count} ανάρτηση} other {{count} αναρτήσεις}} επισυνάπτονται",
  "report_notification.categories.legal": "Νομικά",
  "report_notification.categories.legal_sentence": "παράνομο περιεχόμενο",
  "report_notification.categories.other": "Άλλες",
  "report_notification.categories.other_sentence": "άλλο",
  "report_notification.categories.spam": "Ανεπιθύμητα",
  "report_notification.categories.spam_sentence": "ανεπιθύμητα",
  "report_notification.categories.violation": "Παραβίαση κανόνα",
  "report_notification.categories.violation_sentence": "παραβίαση κανόνα",
  "report_notification.open": "Άνοιγμα αναφοράς",
  "search.clear": "Εκκαθάριση αναζήτησης",
  "search.no_recent_searches": "Καμία πρόσφατη αναζήτηση",
  "search.placeholder": "Αναζήτηση",
  "search.quick_action.account_search": "Προφίλ που αντιστοιχούν με {x}",
  "search.quick_action.go_to_account": "Μετάβαση στο προφίλ {x}",
  "search.quick_action.go_to_hashtag": "Μετάβαση στην ετικέτα {x}",
  "search.quick_action.open_url": "Άνοιγμα διεύθυνσης URL στο Mastodon",
  "search.quick_action.status_search": "Αναρτήσεις που αντιστοιχούν με {x}",
  "search.search_or_paste": "Αναζήτηση ή εισαγωγή URL",
  "search_popout.full_text_search_disabled_message": "Μη διαθέσιμο στο {domain}.",
  "search_popout.full_text_search_logged_out_message": "Διαθέσιμο μόνο όταν συνδεθείς.",
  "search_popout.language_code": "κωδικός ISO γλώσσας",
  "search_popout.options": "Επιλογές αναζήτησης",
  "search_popout.quick_actions": "Γρήγορες ενέργειες",
  "search_popout.recent": "Πρόσφατες αναζητήσεις",
  "search_popout.specific_date": "συγκεκριμένη ημερομηνία",
  "search_popout.user": "χρήστης",
  "search_results.accounts": "Προφίλ",
  "search_results.all": "Όλα",
  "search_results.hashtags": "Ετικέτες",
  "search_results.no_results": "Κανένα αποτέλεσμα.",
  "search_results.no_search_yet": "Δοκίμασε να ψάξεις για αναρτήσεις, προφίλ ή ετικέτες.",
  "search_results.see_all": "Δες τα όλα",
  "search_results.statuses": "Αναρτήσεις",
  "search_results.title": "Αναζήτηση για «{q}»",
  "server_banner.about_active_users": "Άτομα που χρησιμοποιούν αυτόν τον διακομιστή κατά τις τελευταίες 30 ημέρες (Μηνιαία Ενεργοί Χρήστες)",
  "server_banner.active_users": "ενεργοί χρήστες",
  "server_banner.administered_by": "Διαχειριστής:",
  "server_banner.is_one_of_many": "Το {domain} είναι ένας από τους πολλούς ανεξάρτητους διακομιστές Mastodon που μπορείς να χρησιμοποιήσεις για να συμμετάσχεις στο fediverse.",
  "server_banner.more_about_this_server": "Περισσότερα για αυτόν τον διακομιστή",
  "server_banner.server_stats": "Στατιστικά διακομιστή:",
  "sign_in_banner.create_account": "Δημιουργία λογαριασμού",
  "sign_in_banner.follow_anyone": "Ακολούθησε οποιονδήποτε κατά μήκος του fediverse και δες τα όλα με χρονολογική σειρά. Δεν υπάρχουν αλγόριθμοι, διαφημίσεις ή clickbait ούτε για δείγμα.",
  "sign_in_banner.mastodon_is": "Το Mastodon είναι ο καλύτερος τρόπος για να συμβαδίσεις με τα γεγονότα.",
  "sign_in_banner.sign_in": "Σύνδεση",
  "sign_in_banner.sso_redirect": "Συνδεθείτε ή Εγγραφείτε",
  "skip_links.hotkey": "<span>Πλήκτρο συντόμευσης</span> {hotkey}",
  "skip_links.skip_to_content": "Μετάβαση στο κύριο περιεχόμενο",
  "skip_links.skip_to_navigation": "Μετάβαση στην κύρια πλοήγηση",
  "status.admin_account": "Άνοιγμα διεπαφής συντονισμού για @{name}",
  "status.admin_domain": "Άνοιγμα διεπαφής συντονισμού για {domain}",
  "status.admin_status": "Άνοιγμα αυτής της ανάρτησης σε διεπαφή συντονισμού",
  "status.all_disabled": "Ενισχύσεις και παραθέσεις είναι απενεργοποιημένες",
  "status.block": "Αποκλεισμός @{name}",
  "status.bookmark": "Σελιδοδείκτης",
  "status.cancel_reblog_private": "Ακύρωση ενίσχυσης",
  "status.cannot_quote": "Δεν επιτρέπεται να παραθέσετε αυτή την ανάρτηση",
  "status.cannot_reblog": "Αυτή η ανάρτηση δεν μπορεί να ενισχυθεί",
  "status.contains_quote": "Περιέχει παράθεση",
  "status.context.loading": "Φόρτωση περισσότερων απαντήσεων",
  "status.context.loading_error": "Αδυναμία φόρτωσης νέων απαντήσεων",
  "status.context.loading_success": "Νέες απαντήσεις φορτώθηκαν",
  "status.context.more_replies_found": "Βρέθηκαν περισσότερες απαντήσεις",
  "status.context.retry": "Επανάληψη",
  "status.context.show": "Εμφάνιση",
  "status.continued_thread": "Συνεχιζόμενο νήμα",
  "status.copy": "Αντιγραφή συνδέσμου ανάρτησης",
  "status.delete": "Διαγραφή",
  "status.delete.success": "Η ανάρτηση διαγράφηκε",
  "status.detailed_status": "Προβολή λεπτομερούς συνομιλίας",
  "status.direct": "Ιδιωτική επισήμανση @{name}",
  "status.direct_indicator": "Ιδιωτική επισήμανση",
  "status.edit": "Επεξεργασία",
  "status.edited": "Τελευταία επεξεργασία {date}",
  "status.edited_x_times": "Επεξεργάστηκε {count, plural, one {{count} φορά} other {{count} φορές}}",
  "status.embed": "Απόκτηση κώδικα ενσωμάτωσης",
  "status.favourite": "Αγαπημένα",
  "status.favourites_count": "{count, plural, one {{counter} αγαπημένο} other {{counter} αγαπημένα}}",
  "status.filter": "Φιλτράρισμα αυτής της ανάρτησης",
  "status.history.created": "{name} δημιούργησε στις {date}",
  "status.history.edited": "{name} επεξεργάστηκε στις {date}",
  "status.load_more": "Φόρτωσε περισσότερα",
  "status.media.open": "Κάνε κλικ για άνοιγμα",
  "status.media.show": "Κάνε κλικ για εμφάνιση",
  "status.media_hidden": "Κρυμμένο πολυμέσο",
  "status.mention": "Επισήμανση @{name}",
  "status.more": "Περισσότερα",
  "status.mute": "Σίγαση @{name}",
  "status.mute_conversation": "Σίγαση συνομιλίας",
  "status.open": "Επέκταση ανάρτησης",
  "status.pin": "Καρφίτσωσε στο προφίλ",
  "status.quote": "Παράθεση",
  "status.quote.cancel": "Ακύρωση παράθεσης",
  "status.quote_error.blocked_account_hint.title": "Αυτή η ανάρτηση είναι κρυμμένη επειδή έχετε μπλοκάρει τον/την @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Αυτή η ανάρτηση είναι κρυμμένη επειδή έχετε μπλοκάρει το {domain}.",
  "status.quote_error.filtered": "Κρυμμένη λόγω ενός από τα φίλτρα σου",
  "status.quote_error.limited_account_hint.action": "Εμφάνιση ούτως ή άλλως",
  "status.quote_error.limited_account_hint.title": "Αυτός ο λογαριασμός έχει κρυφτεί από τους συντονιστές του {domain}.",
  "status.quote_error.muted_account_hint.title": "Αυτή η ανάρτηση είναι κρυμμένη επειδή έχετε κάνει σίγαση τον/την @{name}.",
  "status.quote_error.not_available": "Ανάρτηση μη διαθέσιμη",
  "status.quote_error.pending_approval": "Ανάρτηση σε αναμονή",
  "status.quote_error.pending_approval_popout.body": "Στο Mastodon, μπορείς να ελέγξεις αν κάποιος μπορεί να σε παραθέσει. Αυτή η ανάρτηση εκκρεμεί ενώ λαμβάνουμε την έγκριση του αρχικού συντάκτη.",
  "status.quote_error.revoked": "Η ανάρτηση αφαιρέθηκε από τον συντάκτη",
  "status.quote_followers_only": "Μόνο οι ακόλουθοι μπορούν να παραθέσουν αυτή την ανάρτηση",
  "status.quote_manual_review": "Ο συντάκτης θα επανεξετάσει χειροκίνητα",
  "status.quote_noun": "Παράθεση",
  "status.quote_policy_change": "Άλλαξε ποιός μπορεί να κάνει παράθεση",
  "status.quote_post_author": "Παρατίθεται μια ανάρτηση από @{name}",
  "status.quote_private": "Ιδιωτικές αναρτήσεις δεν μπορούν να παρατεθούν",
  "status.quotes.empty": "Κανείς δεν έχει παραθέσει αυτή την ανάρτηση ακόμη. Μόλις το κάνει, θα εμφανιστεί εδώ.",
  "status.quotes.local_other_disclaimer": "Οι παραθέσεις που απορρίφθηκαν από τον συντάκτη δε θα εμφανιστούν.",
  "status.quotes.remote_other_disclaimer": "Μόνο παραθέσεις από το {domain} είναι εγγυημένες ότι θα εμφανιστούν εδώ. Παραθέσεις που απορρίφθηκαν από τον συντάκτη δε θα εμφανιστούν.",
  "status.quotes_count": "{count, plural, one {{counter} παράθεση} other {{counter} παραθέσεις}}",
  "status.read_more": "Διάβασε περισότερα",
  "status.reblog": "Ενίσχυση",
  "status.reblog_or_quote": "Ενίσχυση ή παράθεση",
  "status.reblog_private": "Μοιράσου ξανά με τους ακόλουθούς σου",
  "status.reblogged_by": "{name} προώθησε",
  "status.reblogs.empty": "Κανείς δεν ενίσχυσε αυτή την ανάρτηση ακόμη. Μόλις το κάνει κάποιος, θα εμφανιστεί εδώ.",
  "status.reblogs_count": "{count, plural, one {{counter} ενίσχυση} other {{counter} ενισχύσεις}}",
  "status.redraft": "Σβήσε & ξαναγράψε",
  "status.remove_bookmark": "Αφαίρεση σελιδοδείκτη",
  "status.remove_favourite": "Κατάργηση από τα αγαπημένα",
  "status.remove_quote": "Αφαίρεση",
  "status.replied_in_thread": "Απάντησε σε νήμα",
  "status.replied_to": "Απάντησε στον χρήστη {name}",
  "status.reply": "Απάντησε",
  "status.replyAll": "Απάντησε στο νήμα",
  "status.report": "Αναφορά @{name}",
  "status.request_quote": "Αίτημα για παράθεση",
  "status.revoke_quote": "Αφαίρεση της ανάρτησης μου από την ανάρτηση του/της @{name}",
  "status.sensitive_warning": "Ευαίσθητο περιεχόμενο",
  "status.share": "Κοινοποίηση",
  "status.show_less_all": "Δείξε λιγότερο για όλες",
  "status.show_more_all": "Δείξε περισσότερο για όλες",
  "status.show_original": "Εμφάνιση αρχικού",
  "status.title.with_attachments": "{user} δημοσίευσε {attachmentCount, plural, one {ένα συνημμένο} other {{attachmentCount} συνημμένα}}",
  "status.translate": "Μετάφραση",
  "status.translated_from_with": "Μεταφράστηκε από {lang} χρησιμοποιώντας {provider}",
  "status.uncached_media_warning": "Μη διαθέσιμη προεπισκόπηση",
  "status.unmute_conversation": "Άρση σίγασης συνομιλίας",
  "status.unpin": "Ξεκαρφίτσωσε από το προφίλ",
  "subscribed_languages.lead": "Μόνο αναρτήσεις σε επιλεγμένες γλώσσες θα εμφανίζονται στην αρχική σου και θα παραθέτονται ροές μετά την αλλαγή. Επέλεξε καμία για να λαμβάνεις αναρτήσεις σε όλες τις γλώσσες.",
  "subscribed_languages.save": "Αποθήκευση αλλαγών",
  "subscribed_languages.target": "Αλλαγή εγγεγραμμένων γλωσσών για {target}",
  "tabs_bar.home": "Αρχική",
  "tabs_bar.menu": "Μενού",
  "tabs_bar.notifications": "Ειδοποιήσεις",
  "tabs_bar.publish": "Νέα Ανάρτηση",
  "tabs_bar.search": "Αναζήτηση",
  "tag.remove": "Αφαίρεση",
  "terms_of_service.effective_as_of": "Ενεργό από {date}",
  "terms_of_service.title": "Όροι Παροχής Υπηρεσιών",
  "terms_of_service.upcoming_changes_on": "Επερχόμενες αλλαγές στις {date}",
  "time_remaining.days": "απομένουν {number, plural, one {# ημέρα} other {# ημέρες}}",
  "time_remaining.hours": "απομένουν {number, plural, one {# ώρα} other {# ώρες}}",
  "time_remaining.minutes": "απομένουν {number, plural, one {# λεπτό} other {# λεπτά}}",
  "time_remaining.moments": "Στιγμές που απομένουν",
  "time_remaining.seconds": "απομένουν {number, plural, one {# δευτερόλεπτο} other {# δευτερόλεπτα}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} άτομο} other {{counter} άτομα}} {days, plural, one {την τελευταία ημέρα} other {τις τελευταίες {days} ημέρες}}",
  "trends.trending_now": "Δημοφιλή τώρα",
  "ui.beforeunload": "Το προσχέδιό σου θα χαθεί αν φύγεις από το Mastodon.",
  "units.short.billion": "{count}Δις",
  "units.short.million": "{count}Εκ",
  "units.short.thousand": "{count}Χιλ",
  "upload_area.title": "Κάνε Drag & drop για να ανεβάσεις",
  "upload_button.label": "Πρόσθεσε εικόνες, ένα βίντεο ή ένα αρχείο ήχου",
  "upload_error.limit": "Υπέρβαση ορίου μεγέθους ανεβασμένων αρχείων.",
  "upload_error.poll": "Στις δημοσκοπήσεις δεν επιτρέπεται η μεταφόρτωση αρχείου.",
  "upload_error.quote": "Δεν επιτρέπεται η μεταφόρτωση αρχείου με παραθέσεις.",
  "upload_form.drag_and_drop.instructions": "Για να επιλέξετε ένα συνημμένο αρχείο πολυμέσων, πατήστε το Space ή το Enter. Ενώ το σέρνετε, χρησιμοποιήστε τα πλήκτρα βέλους για να μετακινήσετε το συνημμένο αρχείο πολυμέσων προς οποιαδήποτε κατεύθυνση. Πατήστε ξανά το Space ή το Enter για να αποθέσετε το συνημμένο αρχείο πολυμέσων στη νέα του θέση ή πατήστε το Escape για ακύρωση.",
  "upload_form.drag_and_drop.on_drag_cancel": "Η μετακίνηση ακυρώθηκε. Έγινε απόθεση του συνημμένου αρχείου πολυμέσων «{item}».",
  "upload_form.drag_and_drop.on_drag_end": "Έγινε απόθεση του συνημμένου αρχείου πολυμέσων «{item}».",
  "upload_form.drag_and_drop.on_drag_over": "Έγινε μετακίνηση του συνημμένου αρχείου πολυμέσων «{item}».",
  "upload_form.drag_and_drop.on_drag_start": "Έγινε επιλογή του συνημμένου αρχείου πολυμέσων «{item}».",
  "upload_form.edit": "Επεξεργασία",
  "upload_progress.label": "Μεταφόρτωση...",
  "upload_progress.processing": "Επεξεργασία…",
  "username.taken": "Αυτό το όνομα χρήστη χρησιμοποιείται. Δοκίμασε ένα άλλο",
  "video.close": "Κλείσε το βίντεο",
  "video.download": "Λήψη αρχείου",
  "video.exit_fullscreen": "Έξοδος από πλήρη οθόνη",
  "video.expand": "Επέκταση βίντεο",
  "video.fullscreen": "Πλήρης οθόνη",
  "video.hide": "Απόκρυψη βίντεο",
  "video.mute": "Σίγαση",
  "video.pause": "Παύση",
  "video.play": "Αναπαραγωγή",
  "video.skip_backward": "Παράλειψη πίσω",
  "video.skip_forward": "Παράλειψη εμπρός",
  "video.unmute": "Άρση σίγασης",
  "video.volume_down": "Μείωση έντασης",
  "video.volume_up": "Αύξηση έντασης",
  "visibility_modal.button_title": "Ορισμός ορατότητας",
  "visibility_modal.direct_quote_warning.text": "Εάν αποθηκεύσετε τις τρέχουσες ρυθμίσεις, η ενσωματωμένη παράθεση θα μετατραπεί σε σύνδεσμο.",
  "visibility_modal.direct_quote_warning.title": "Οι παραθέσεις δεν μπορούν να ενσωματωθούν σε ιδιωτικές επισημάνσεις",
  "visibility_modal.header": "Ορατότητα και αλληλεπίδραση",
  "visibility_modal.helper.direct_quoting": "Ιδιωτικές επισημάνσεις που έχουν συνταχθεί στο Mastodon δεν μπορούν να γίνουν παράθεση από άλλους.",
  "visibility_modal.helper.privacy_editing": "Η ορατότητα δεν μπορεί να αλλάξει μετά τη δημοσίευση μιας ανάρτησης.",
  "visibility_modal.helper.privacy_private_self_quote": "Αυτο-παραθέσεις ιδιωτικών αναρτήσεων δεν μπορούν να γίνουν δημόσιες.",
  "visibility_modal.helper.private_quoting": "Αναρτήσεις για ακολούθους μόνο που έχουν συνταχθεί στο Mastodon, δεν μπορούν να γίνουν παράθεση από άλλους.",
  "visibility_modal.helper.unlisted_quoting": "Όταν άτομα σας παραθέτουν, η ανάρτησή τους θα είναι επίσης κρυμμένη από τις δημοφιλείς ροές.",
  "visibility_modal.instructions": "Ελέγξτε ποιος μπορεί να αλληλεπιδράσει με αυτή την ανάρτηση. Μπορείτε επίσης να εφαρμόσετε ρυθμίσεις σε όλες τις μελλοντικές αναρτήσεις πλοηγώντας σε <link>Προτιμήσεις > Προεπιλογές ανάρτησης</link>.",
  "visibility_modal.privacy_label": "Ορατότητα",
  "visibility_modal.quote_followers": "Μόνο ακόλουθοι",
  "visibility_modal.quote_label": "Ποιος μπορεί να παραθέσει",
  "visibility_modal.quote_nobody": "Μόνο εγώ",
  "visibility_modal.quote_public": "Οποιοσδήποτε",
  "visibility_modal.save": "Αποθήκευση"
}
